<template>
  <v-app>
    <div id="app" class="ma-lg-10 ml-lg-10 ma-md-10 ml-md-10 d-none d-md-block">
      <!-- <div id="app" class="web-camera-container">
  <div class="camera-button">
      <v-btn type="button" class="button is-rounded" :class="{ 'is-primary' : !isCameraOpen, 'is-danger' : isCameraOpen}" @click="toggleCamera">
        <span v-if="!isCameraOpen">Open Camera</span>
        <span v-else>Close Camera</span>
      </v-btn>
  </div>
  
  <div v-show="isCameraOpen && isLoading" class="camera-loading">

  </div>
  
  <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
    
    <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
      
    <video v-show="!isPhotoTaken" ref="camera" :width="450" :height="337.5" autoplay></video>
    
    <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="450" :height="337.5"></canvas>
  </div>
  
  <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
    <button type="button" class="button" @click="takePhoto">
      <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png">
    </button>
  </div>
  
  <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
    <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button" @click="downloadImage">
      Download
    </a>
  </div>
</div> -->
      <div class="px-4">
        <div id="mobile-app" class="py-md-7 d-block d-md-none"></div>
        <div class="px-md-3">
          <v-list-item class="pl-0 pl-md-1">
            <v-list-item-content>
              <v-list-item-title class="text-start"
                style="color: #000000; font-size: 20px; font-weight: 559; line-height: 24px; letter-spacing: -1px"
                :class="$vuetify.breakpoint.smAndDown ? 'title-align mobile-version-title' : ''"> Profile
                Details</v-list-item-title>
              <v-list-item-subtitle class="text-start pt-1"
                style="color: #666666; font-size: 12px; font-weight: 469; line-height: 14px; white-space: normal; word-break: break-word;"
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-subtitle sub-align' : ''">These details are used
                for all communication related to your account. </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <!-- <p class="font-weight-bold fs-22 mb-0">Profile Details 
          
        </p>
        <p class="subtitle-2 txt-666">
          These details are used for all communication related to your account.
        </p> -->
        </div>
        <v-divider></v-divider>
        <v-card class="py-md-6 px-md-3 mt-6 mb-md-6" :outlined="$vuetify.breakpoint.smAndDown ? false : true"
          elevation="0" width="100%">
          <p class="subtitle-1 txt-666 font-weight-medium"
            :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 sub-align' : ''">Personal Details</p>
          <!-- {{accountstatus}} -->
          <v-row no-glutters>
            <v-col cols="12" sm="6" md="4">
              <v-text-field readonly :loading="profileLoader" v-model="profileData.Pan_Name" append-icon=""
                label="NAME AS PER PAN" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''"></v-text-field>
            </v-col>
            <!-- <v-col cols="12" sm="6" md="4">
            <v-text-field   readonly :loading="profileLoader"
              v-model="profileData.CLIENT_NAME" append-icon="" label="NAME"></v-text-field>
          </v-col> -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field readonly :loading="profileLoader" v-model="profileData.BIRTH_DATE" append-icon=""
                label="BIRTH DATE" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field readonly :loading="profileLoader" v-model="profileData.Marital_status" append-icon=""
                label="MARITAL STATUS" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''"></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field readonly :loading="profileLoader" :value="`*******${hashpan}`" append-icon=""
                label="PAN NUMBER" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''"></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field :loading="profileLoader"  readonly label="EMAIL" :disabled="emailDisable"
                v-model="profileData.CLIENT_ID_MAIL" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''">
                <template #append>

                  <!-- ---------------------------------- -->
                  <!-- <div v-if="accountstatus != 'client_close'">
                    <v-btn v-if="!emailDisable" @click="mobileEdit('email')" class="rounded"
                      style="background-color: #000" :style="{ background: !last7days ? 'grey' : '#000' }" elevation="0"
                      text small :disabled="accountstatus == 'client_close' || !last7days">
                      <span
                        :style="$vuetify.breakpoint.smAndDown ? 'color: #fff; font-size: 12px' : 'color: #fff; font-size: 10px'">Edit</span>
                    </v-btn>
                  </div> -->

                  <div v-if="accountstatus != 'client_close'">
                    <v-tooltip bottom open-on-click v-if="(!emailDisable && !last7days) || profileData.CATEGORY != 'I'" color="black">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <v-btn class="rounded" :disabled="profileData.CATEGORY != 'I' || rekyc_status == 'Yes'" elevation="0" text small :style="{
                            background: 'grey',
                            cursor: 'not-allowed',
                            pointerEvents: 'auto'
                          }" @click.stop>
                            <span :style="$vuetify.breakpoint.smAndDown
                              ? 'color: #fff; font-size: 12px; opacity: 0.5'
                              : 'color: #fff; font-size: 10px; opacity: 0.5'">
                              Edit 
                            </span>
                          </v-btn>
                        </div>
                      </template>
                      <span>
                      {{profileData.CATEGORY != 'I' ?'Non-individual accounts can’t modify data here. Please contact support at (+91) 93 8010 8010 for help.' :  'Modification request not allowed within 7 days of activation'}}
                      </span>
                    </v-tooltip>

                    <v-btn v-else-if="!emailDisable && last7days" @click="mobileEdit('email')" class="rounded"
                      style="background-color: #000" elevation="0" text small :disabled="profileData.CATEGORY != 'I' || rekyc_status == 'Yes'">
                      <span :style="$vuetify.breakpoint.smAndDown
                        ? 'color: #fff; font-size: 12px'
                        : 'color: #fff; font-size: 10px'">
                        Edit
                      </span>
                    </v-btn>
                  </div>

                  <div v-if="accountstatus == 'client_close'">
                    <v-tooltip color="black" :disabled="!last7days" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-btn :disabled="profileData.CATEGORY != 'I'" class="rounded" elevation="0" small > Edit  </v-btn>
                        </span>
                      </template>
                      <span>Your trading account is closed</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field id="mobileedit" readonly :disabled="mobileDisable" :loading="profileLoader"
                v-model="profileData.MOBILE_NO" label="MOBILE"
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''">
                <template #append>

                  <!-- -------------------------------------------- -->
                  <!-- <div v-if="accountstatus != 'client_close'">
                    <v-btn v-if="!mobileDisable" @click="mobileEdit('mobile')" class="rounded"
                      style="background-color: #000" :style="{ background: !last7days ? 'grey' : '#000' }" elevation="0"
                      text small :disabled="accountstatus == 'client_close' || !last7days">
                      <span
                        :style="$vuetify.breakpoint.smAndDown ? 'color: #fff; font-size: 12px' : 'color: #fff; font-size: 10px'">Edit</span>
                    </v-btn>
                  </div> -->

                  <div v-if="accountstatus != 'client_close'">
                    <v-tooltip bottom color="black" open-on-click v-if="(!mobileDisable && !last7days || profileData.CATEGORY != 'I')">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <v-btn class="rounded" elevation="0" text small :disabled="profileData.CATEGORY != 'I' || rekyc_status == 'Yes'"
                          :style="{background: profileData.CATEGORY != 'I' ? 'grey' : '#000'}" @click.stop>
                            <span :style="$vuetify.breakpoint.smAndDown
                              ? 'color: #fff; font-size: 12px; opacity: 0.5'
                              : 'color: #fff; font-size: 10px; opacity: 0.5'">
                              Edit
                            </span>
                          </v-btn>
                        </div>
                      </template>
                      <span>
                      {{profileData.CATEGORY != 'I' ? 'Non-individual accounts can’t modify data here. Please contact support at (+91) 93 8010 8010 for help.' :  'Modification request not allowed within 7 days of activation'}}
                      </span>
                    </v-tooltip>

                    <v-btn v-else-if="!mobileDisable && last7days" @click="mobileEdit('mobile')" class="rounded"
                      :style="{ background: '#000' }" elevation="0" :disabled="profileData.CATEGORY != 'I' || rekyc_status == 'Yes'" text small>
                      <span :style="$vuetify.breakpoint.smAndDown
                        ? 'color: #fff; font-size: 12px'
                        : 'color: #fff; font-size: 10px'">
                        Edit
                      </span>
                    </v-btn>
                  </div>


                  <div v-if="accountstatus == 'client_close'">
                    <v-tooltip color="black" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-btn :disabled="profileData.CATEGORY != 'I' || rekyc_status == 'Yes'" class="rounded" elevation="0" small> Edit </v-btn>
                        </span>
                      </template>
                      <span>Your trading account is closed</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="8">
              <v-text-field :loading="profileLoader" readonly :disabled="addressDisable" label="ADDRESS"
                v-model="profileData.CL_RESI_ADD1" @click:append="mobileEdit('address')"
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''">
                <template #append>
                  
                  <!-- <div v-if="accountstatus != 'client_close'">
                    <v-btn v-if="!addressDisable" @click="mobileEdit('address')" class="rounded" elevation="0"
                      :style="{ background: (!atve_sts || !last7days) ? 'grey' : '#000' }" text small
                      :disabled="accountstatus == 'client_close' || !atve_sts || !last7days">
                      <span :style="{
                        color: '#fff',
                        fontSize: $vuetify.breakpoint.smAndDown ? '12px' : '10px',
                      }">Edit</span>
                    </v-btn>
                  </div> -->


                 <div v-if="accountstatus != 'client_close'">
                    <v-tooltip bottom color="black" open-on-click v-if="(!addressDisable && !atve_sts) || profileData.CATEGORY != 'I' ">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <v-btn class="rounded" elevation="0" text small :disabled="profileData.CATEGORY != 'I'" :style="{
                            background: (!atve_sts || !last7days || profileData.CATEGORY != 'I') ? 'grey' : '#000',
                            pointerEvents: 'auto',
                            cursor: 'not-allowed',
                          }">
                            <span :style="{
                              color: '#fff',
                              fontSize: $vuetify.breakpoint.smAndDown ? '12px' : '10px',
                              opacity: !atve_sts ? 0.5 : 1,
                            }">
                              Edit 
                            </span>
                          </v-btn>
                        </div>
                      </template>
                      <span>
                     {{profileData.CATEGORY != 'I' ? 'Non-individual accounts can’t modify data here. Please contact support at (+91) 93 8010 8010 for help.' : !atve_sts  ? 'Modification not allowed for inactive client codes. Please reactivate the account.' : 'Modification request not allowed within 7 days of activation'}}
                      </span>
                    </v-tooltip>
                    <v-btn v-else-if="!addressDisable && last7days" @click="mobileEdit('address')" class="rounded"
                      :style="{ background: '#000' }" elevation="0" :disabled="profileData.CATEGORY != 'I'" text small>
                      <span :style="$vuetify.breakpoint.smAndDown
                        ? 'color: #fff; font-size: 12px'
                        : 'color: #fff; font-size: 10px'">
                        Edit
                      </span>
                    </v-btn>
                     <!-- <v-tooltip bottom open-on-click v-if="(!addressDisable && !atve_sts) || profileData.CATEGORY != 'I' ">
                    <v-btn v-if="!addressDisable " @click="mobileEdit('address')" class="rounded" elevation="0"
                      :style="{ background: !atve_sts ? 'grey' : '#000' }" text small
                      :disabled="accountstatus == 'client_close' || !atve_sts || profileData.CATEGORY != 'I'">
                      <span :style="{
                        color: '#fff',
                        fontSize: $vuetify.breakpoint.smAndDown ? '12px' : '10px',
                      }" >                      {{profileData.CATEGORY != 'I' ? 'Non-individual accounts can’t modify data here. Please contact support at (+91) 93 8010 8010 for help.'  : 'Modification request not allowed within 7 days of activation'}}Edit  </span>
                    </v-btn>
                    </v-tooltip> -->
                  </div>


                  <div v-if="accountstatus == 'client_close'">
                    <v-tooltip color="black" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-btn :disabled="profileData.CATEGORY != 'I'" class="rounded" elevation="0" small> Edit </v-btn>
                        </span>
                      </template>
                      <span>Your trading account is closed</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-text-field>
            </v-col>

            <!-- <v-col cols="12" sm="6" md="4">
                  <v-text-field id="mobileedit"   
                    readonly :disabled="mobileDisable" :loading="profileLoader" v-model="profileData.MOBILE_NO"
                    :append-icon="'mdi-pencil-circle-outline'" label="MOBILE"
                    @click:append="mobileEdit('mobile')"></v-text-field>
                </v-col> -->
          </v-row>
          <v-card rounded="lg" v-if="mobStatus.mobile_status == 'e-signed pending'" color="#FCEFD4" elevation="0"
            class="">
            <div class="px-2 py-1">
              <p style="font-size: 10.5px;  font-weight: 459; margin: 0; display: inline; color: #666666"
                class="d-none d-md-block">
                Your Mobile Change request is not yet Completed,<span style="color: #0037b7; cursor: pointer"
                  @click="digioEsign(mobStatus.mobile_file_id, mobStatus.mob_client_email.toUpperCase(), mobStatus.mob_session), (editType = 'mobile_change')">
                  Click here esign</span>
                <span @click="(editType = 'mobile_change'), (fileide = mobStatus.mobile_file_id), (confirmation = true)"
                  class="mt-1 mr-2 " style="color: red; cursor: pointer; float: right">Cancel request</span>
              </p>
              <div class="mt-1  d-md-none">
                <p style="font-size: 10.5px;  font-weight: 459; margin: 0; display: inline; color: #666666">Your Mobile
                  Change
                  request is not yet Completed,</p>
                <div class="d-flex">
                  <span style="color: #0037b7; cursor: pointer"
                    @click="digioEsign(mobStatus.mobile_file_id, mobStatus.mob_client_email.toUpperCase(), mobStatus.mob_session), (editType = 'mobile_change')">
                    Click here esign</span>
                  <span
                    @click="(editType = 'mobile_change'), (fileide = mobStatus.mobile_file_id), (confirmation = true)"
                    class="mt-1 mr-2 ml-auto" style="color: red; cursor: pointer; float: right">Cancel request</span>
                </div>
              </div>
            </div>
          </v-card>
          <v-card rounded="lg" v-if="mobStatus.mobile_status == 'e-signed completed'" color="#FCEFD4" elevation="0"
            class="">
            <div class="px-2 py-1">
              <p style="font-size: 10.5px; font-weight: 459; margin: 0; display: inline; color: #666666">
                Your Mobile Change request is in process
                <!-- <span style="color: #0037B7;cursor: pointer;"> Click here esign</span> -->
              </p>
            </div>
          </v-card>
          <v-card rounded="lg" v-if="mobStatus.email_status == 'e-signed pending'" color="#FCEFD4" elevation="0"
            class="mt-4">
            <div class="px-2 py-1">
              <p style="font-size: 10.5px; font-weight: 459; margin: 0; display: inline; color: #666666"
                class="d-none d-md-block">
                Your Email Change request is not yet Completed,<span style="color: #0037b7; cursor: pointer"
                  @click="digioEsign(mobStatus.email_file_id, mobStatus.email_new_email_id.toLowerCase(), mobStatus.email_session), (editType = 'email_change')">
                  Click here esign</span>
                <span @click="(editType = 'email_change'), (fileide = mobStatus.email_file_id), (confirmation = true)"
                  class="mt-1 mr-2" style="color: red; cursor: pointer; float: right">Cancel request</span>
              </p>

              <div class="d-md-none">
                <p style="font-size: 10.5px;  font-weight: 459; margin: 0; display: inline; color: #666666"> Your Email
                  Change
                  request is not yet Completed,</p>
                <div class="d-flex">
                  <span style="color: #0037b7; cursor: pointer"
                    @click="digioEsign(mobStatus.email_file_id, mobStatus.email_new_email_id.toLowerCase(), mobStatus.email_session), (editType = 'email_change')">
                    Click here esign</span>

                  <span @click="(editType = 'email_change'), (fileide = mobStatus.email_file_id), (confirmation = true)"
                    class="mt-1 mr-2 ml-auto" style="color: red; cursor: pointer; float: right">Cancel request</span>

                </div>

              </div>



              <!-- <span
                @click="editType = 'email_change', fileide = mobStatus.email_file_id, confirmation = true"
                class="mt-1 mr-2 d-none d-sm-flex d-sm-flex d-md-flex d-lg-none d-xl-none" style="color: red;cursor: pointer;float:right">Cancel request</span> -->
            </div>
          </v-card>
          <v-card rounded="lg" v-if="mobStatus.email_status == 'e-signed completed'" color="#FCEFD4" elevation="0"
            class="mt-4">
            <div class="px-2 py-1">
              <p style="font-size: 10.5px; font-weight: 459; margin: 0; display: inline; color: #666666">
                Your Email Change request for is in process
                <!-- <span style="color: #0037B7;cursor: pointer;"> Click here esign</span> -->
              </p>
            </div>
          </v-card>
          <v-card rounded="lg" v-if="mobStatus.address_status == 'e-signed pending'" color="#FCEFD4" elevation="0"
            class="mt-4">
            <div class="px-2 py-1">
              <p style="font-size: 10.5px; font-weight: 459; margin: 0; display: inline; color: #666666"
                class="d-none d-md-block">
                Your Address Change request is not yet Completed,<span style="color: #0037b7; cursor: pointer"
                  @click="(editType = 'address_change'), digioEsign(mobStatus.address_file_id, mobStatus.address_client_email.toLowerCase(), mobStatus.address_session)">
                  Click here esign</span><span
                  @click="(editType = 'address_change'), (fileide = mobStatus.address_file_id), (confirmation = true)"
                  class="mt-1 mr-2" style="color: red; cursor: pointer; float: right">Cancel request</span>
              </p>

              <div class="d-md-none">
                <p style="font-size: 10.5px; font-weight: 459; margin: 0; display: inline; color: #666666"
                  :class="$vuetify.breakpoint.smAndDown ? 'fs-12' : ''">
                  Your Address Change request is not yet Completed,</p>
                <div class="d-flex">
                  <span style="color: #0037b7; cursor: pointer"
                    @click="(editType = 'address_change'), digioEsign(mobStatus.address_file_id, mobStatus.address_client_email.toLowerCase(), mobStatus.address_session)">
                    Click here esign</span>
                  <span
                    @click="(editType = 'address_change'), (fileide = mobStatus.address_file_id), (confirmation = true)"
                    class="mt-1 mr-2 ml-auto" style="color: red; cursor: pointer; float: right">Cancel request</span>
                </div>
              </div>



            </div>
          </v-card>
          <v-card rounded="lg" v-if="mobStatus.address_status == 'e-signed completed'" color="#FCEFD4" elevation="0"
            class="mt-4">
            <div class="px-2 py-1">
              <p style="font-size: 10.5px; font-weight: 459; margin: 0; display: inline; color: #666666"
                :class="$vuetify.breakpoint.smAndDown ? 'fs-12' : ''">
                Your Address Change request is in process
                <!-- <span style="color: #0037B7;cursor: pointer;"> Click here esign</span> -->
              </p>
            </div>
          </v-card>
        </v-card>

        <v-alert v-if="rekyc_status == 'Yes'"
  border="left"
  color="orange"

  outlined

>
<v-icon color="orange">mdi-alert-outline</v-icon>
Your account is currently under reactivation. During this process, changes to your mobile number and email are not allowed.

</v-alert>

        <!-- <v-card 
                class="py-md-6 mb-md-6 d-md-none"
                elevation="0"
                width="100%"
              >
                <p class="subtitle-1 txt-666 font-weight-medium">
                  Personal Details
                </p>

                <v-row no-glutters>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                       
                      readonly
                      :loading="profileLoader"
                      v-model="profileData.CLIENT_NAME"
                      append-icon=""
                      label="NAME"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                       
                      readonly
                      :loading="profileLoader"
                      :value="`*******${hashpan}`"
                      append-icon=""
                      label="PAN NUMbER"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                       
                      :loading="profileLoader"
                      readonly
                      label="EMAIL"
                      :disabled="emailDisable"
                      :append-icon="'mdi-pencil-circle-outline'"
                      v-model="profileData.CLIENT_ID_MAIL"
                    >
                      <template #append>
                        <v-btn @click="mobileEdit('email')" icon small>
                          <img src="@/assets/pen.svg" alt="pen" />
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      id="mobileedit"
                       
                      readonly
                      :disabled="mobileDisable"
                      :loading="profileLoader"
                      v-model="profileData.MOBILE_NO"
                      :append-icon="'mdi-pencil-circle-outline'"
                      label="MOBILE"
                    >
                      <template #append>
                        <v-btn @click="mobileEdit('mobile')" icon small>
                          <img src="@/assets/pen.svg" alt="pen" />
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="8">
                    <v-text-field
                      :loading="profileLoader"
                      readonly
                      :disabled="addressDisable"
                       
                      :append-icon="'mdi-pencil-circle-outline'"
                      label="ADDRESS"
                      v-model="profileData.CL_RESI_ADD1"
                      @click:append="mobileEdit('address')"
                    >
                      <template #append>
                        <v-btn @click="mobileEdit('address')" icon small>
                          <img src="@/assets/pen.svg" alt="pen" />
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>

                
                </v-row>
                <v-card
                  rounded="lg"
                  v-if="mobStatus.mobile_status == 'e-signed pending'"
                  color="#FCEFD4"
                  elevation="0"
                  class=""
                >
                  <div class="px-2 py-1">
                    <p
                      style="
                        font-size: 10.5px;
                        font-weight: 459;
                        margin: 0;
                        display: inline;
                        color: #666666;
                      "
                    >
                      Your Mobile Change request is not yet Completed,<span
                        style="color: #0037b7; cursor: pointer"
                        @click="
                          digioEsign(
                            mobStatus.mobile_file_id,
                            mobStatus.mob_client_email,
                            mobStatus.mob_session
                          ),
                            (editType = 'mobile_change')
                        "
                      >
                        Click here esign</span
                      >
                    </p>
                  </div>
                </v-card>
                <v-card
                  rounded="lg"
                  v-if="mobStatus.mobile_status == 'e-signed completed'"
                  color="#FCEFD4"
                  elevation="0"
                  class=""
                >
                  <div class="px-2 py-1">
                    <p
                      style="
                        font-size: 10.5px;
                        font-weight: 459;
                        margin: 0;
                        display: inline;
                        color: #666666;
                      "
                    >
                      Your Mobile Change request is in process
                    </p>
                  </div>
                </v-card>
                <v-card
                  rounded="lg"
                  v-if="mobStatus.email_status == 'e-signed pending'"
                  color="#FCEFD4"
                  elevation="0"
                  class="mt-4"
                >
                  <div class="px-2 py-1">
                    <p
                      style="
                        font-size: 10.5px;
                        font-weight: 459;
                        margin: 0;
                        display: inline;
                        color: #666666;
                      "
                    >
                      Your Email Change request is not yet Completed,<span
                        style="color: #0037b7; cursor: pointer"
                        @click="
                          digioEsign(
                            mobStatus.email_file_id,
                            mobStatus.email_new_email_id,
                            mobStatus.email_session
                          ),
                            (editType = 'email_change')
                        "
                      >
                        Click here esign</span
                      >
                    </p>
                  </div>
                </v-card>
                <v-card
                  rounded="lg"
                  v-if="mobStatus.email_status == 'e-signed completed'"
                  color="#FCEFD4"
                  elevation="0"
                  class="mt-4"
                >
                  <div class="px-2 py-1">
                    <p
                      style="
                        font-size: 10.5px;
                        font-weight: 459;
                        margin: 0;
                        display: inline;
                        color: #666666;
                      "
                    >
                      Your Email Change request for (
                      {{ this.mobStatus.email_new_email_id }} ) is in process
                    </p>
                  </div>
                </v-card>
                <v-card
                  rounded="lg"
                  v-if="mobStatus.address_status == 'e-signed pending'"
                  color="#FCEFD4"
                  elevation="0"
                  class="mt-4"
                >
                  <div class="px-2 py-1">
                    <p
                      style="
                        font-size: 10.5px;
                        font-weight: 459;
                        margin: 0;
                        display: inline;
                        color: #666666;
                      "
                    >
                      Your Address Change request is not yet Completed,<span
                        style="color: #0037b7; cursor: pointer"
                        @click="
                          (editType = 'address_change'),
                            digioEsign(
                              mobStatus.address_file_id,
                              mobStatus.address_client_email,
                              mobStatus.address_session
                            )
                        "
                      >
                        Click here esign</span
                      >
                    </p>
                  </div>
                </v-card>
                <v-card
                  rounded="lg"
                  v-if="mobStatus.address_status == 'e-signed completed'"
                  color="#FCEFD4"
                  elevation="0"
                  class="mt-4"
                >
                  <div class="px-2 py-1">
                    <p
                      style="
                        font-size: 10.5px;
                        font-weight: 459;
                        margin: 0;
                        display: inline;
                        color: #666666;
                      "
                    >
                      Your Address Change request is in process
                    </p>
                  </div>
                </v-card>
              </v-card> -->
      </div>
      <v-snackbar class="pt-6 pr-md-6 snakbar-sty rounded-pill" elevation="0" transition="slide-x-reverse-transition"
        v-model="snackbar" :timeout="4000" :value="true" color="warning" text-color="white">
        <v-icon class="mr-2" color="white">mdi-alert-outline</v-icon>
        Session <strong>{{ txt }}</strong> Kindly Login again.
        <v-icon @click="snackbar = false" class="float-right" color="white">mdi-close-circle</v-icon>
      </v-snackbar>
      <v-snackbar style="z-index: 9999" class="pt-6 pr-md-6 snakbar-sty rounded-pill" elevation="0" text-color="white"
        transition="slide-x-reverse-transition" v-model="errorSnackbar" :timeout="4000" :value="true" color="error">
        <v-icon class="mr-2" color="white">mdi-alert-outline</v-icon>
        {{ errtext }}
        <v-icon @click="errorSnackbar = false" class="float-right" color="white">mdi-close-circle</v-icon>
      </v-snackbar>
      <v-snackbar class="pt-6 pr-md-6 snakbar-sty rounded-pill" elevation="0" text-color="white"
        transition="slide-x-reverse-transition" v-model="successSnackbar" :timeout="4000" :value="true" color="#43A833">
        <v-icon class="mr-2" color="white">mdi-alert-outline</v-icon>
        {{ Succtext }}
        <v-icon @click="successSnackbar = false" class="float-right" color="white">mdi-close-circle</v-icon>
      </v-snackbar>
      <v-overlay :value="blurLoader" class="rounded-0" style="z-index: 2000">
        <div class="text-center">
          <v-progress-circular :size="60" :width="4" color="#0037B7" indeterminate></v-progress-circular>
        </div>
      </v-overlay>
      <v-dialog v-model="confirmation" persistent max-width="380">
        <v-card class="rounded-lg px-2 px-md-2">
          <v-card-title class="pr-2">Cancel request? <v-spacer></v-spacer>
            <v-btn icon @click="confirmation = false" v-if="src !== 'mobileapp'">
              <v-icon>mdi-close</v-icon>
            </v-btn></v-card-title>
          <v-card-text>
            Are you sure you want to cancel your
            <b>"{{ this.editType }}"</b> request?
          </v-card-text>
          <v-card-actions class="pb-4">
            <!-- <v-btn
                height="40px"
                block
                color="red darken-1 text-none"
                text
                @click="deleteBankapi"
              >
                Delete
              </v-btn> -->
            <v-btn elevation="0" color="black white--text" rounded block @click="rejectEsign">
              <span class="text-none">Proceed</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editdialog"
        :transition="$vuetify.breakpoint.xsOnly ? 'dialog-bottom-transition' : 'scale-transition'" persistent
        :fullscreen="$vuetify.breakpoint.xsOnly" :max-width="addNewSeg ? '500' : '420'" min-width="390">
        <v-card class="pb-4 rounded-lg px-md-4">
          <v-snackbar style="z-index: 9999" class="pt-6 pr-md-6 snakbar-sty rounded-pill" elevation="0"
            text-color="white" transition="slide-x-reverse-transition" v-model="errorSnackbar" :timeout="4000"
            :value="true" color="error">
            <v-icon class="mr-2" color="white">mdi-alert-outline</v-icon>
            {{ errtext }}
            <v-icon @click="errorSnackbar = false" class="float-right" color="white">mdi-close-circle</v-icon>
          </v-snackbar>
          <div v-if="requestotp">
            <v-form ref="form">
              <v-card-title style="font-size: 16px"
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-title font-weight-bold' : ''">
                Mobile change request <v-spacer></v-spacer>
                <v-btn icon @click="closeBtn" v-if="src !== 'mobileapp'">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <!-- <p class="ma-0 pa-0" style="font-weight:499">Old Mobile number</p> -->
                <p class="ma-0 pa-0 font-weight-medium txt-666"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Present Number</p>
                <v-text-field dense class="pa-0" readonly type="number" hide-spin-buttons
                  v-model="profileData.MOBILE_NO" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''">
                  <!-- <template #prepend-inner>
                <div style="width:30px">
                  <v-img class="mt-1" max-height="16" max-width="16" src="@/assets/mobile-phone.svg"/>
                </div>
              </template> -->
                </v-text-field>
                <p class="ma-0 pa-0" style="font-weight: 499"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">New Mobile number <span
                    style="color: red">*</span></p>
                <v-text-field class="pa-0" required type="number" hide-spin-buttons @keyup="checkSame"
                  :rules="mobileNumberRules" placeholder="Enter Mobile no" v-model="usernewmobile"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''">
                  <template #prepend-inner>
                    <div style="width: 30px">
                      <v-img class="mt-1" max-height="16" max-width="16" src="@/assets/mobile-phone.svg" />
                    </div>
                  </template>
                </v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn elevation="0"
            color="black white--text px-8 "
            rounded
              @click="editdialog = false"
            >
              Close
            </v-btn> -->
                <v-btn height="40px" elevation="0" color="black white--text " rounded block :loading="mobileLoader"
                  @click="sendButtonClicked" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''"
                  class="d-none d-sm-block d-md-block">
                  <span class="text-none px-8">Submit</span>
                </v-btn>
                <v-footer fixed color="white" v-if="$vuetify.breakpoint.xsOnly">
                  <v-btn height="40px" elevation="0" color="black white--text " rounded block :loading="mobileLoader"
                    @click="sendButtonClicked"
                    :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 d-flex mb-3' : ''">
                    <span class="text-none px-8">Submit</span>
                  </v-btn>
                </v-footer>
              </v-card-actions>
            </v-form>
          </div>
          <div v-if="kraImgCapture">
            <v-form ref="form">
              <v-card-title style="font-size: 16px">
                Let's take a selfie<v-spacer></v-spacer>
                <v-btn icon @click="closeBtn" v-if="src !== 'mobileapp'">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <!-- <p class="ma-0 pa-0" style="font-weight:499">Old Mobile number</p> -->
                <p class="ma-0 pa-0 font-weight-medium txt-666">Click a selfie for your Re-KYC verification. Please make
                  sure
                  you are in a well-lit area.</p>
                <div></div>
                <div id="app" class="web-camera-container">
                  <div align="center" class="camera-button mt-4">
                    <v-btn :ripple="false" v-if="!isCameraOpen && !isPhotoTaken" height="40px" elevation="0" outlined style="border: 1px solid #000 !important" rounded block class="text-none" @click="toggleCamera">
                      <span>Open Camera</span>
                    </v-btn>
                    <div v-if="!isCameraOpen && !isPhotoTaken" class="my-2">
                      <span class="font-weight-medium txt-666">OR</span>
                    </div>
                    <v-btn :ripple="false" v-if="!isCameraOpen && !isPhotoTaken" height="40px" elevation="0" outlined style="border: 1px solid #000 !important" rounded block class="text-none" @click="$refs.photoUploadDesktop.click()">
                      <v-icon left small>mdi-upload</v-icon>
                      <span>Upload Photo</span>
                    </v-btn>
                    <input type="file" ref="photoUploadDesktop" accept="image/*" style="display:none" @change="onPhotoUpload" />
                  </div>

                  <div v-show="isCameraOpen && isLoading" class="camera-loading"></div>

                  <div v-if="isCameraOpen || isPhotoTaken" v-show="!isLoading" class="camera-box" :class="{ flash: isShotPhoto }">
                    <div class="camera-shutter" :class="{ flash: isShotPhoto }"></div>

                    <video v-show="!isPhotoTaken && isCameraOpen" ref="camera" width="100%" height="100%" autoplay></video>

                    <div v-show="isPhotoTaken" class="crop-container">
                      <canvas id="photoTaken" ref="canvas" :width="475" :height="520" class="crop-canvas"></canvas>
                      <div v-if="isUploadedPhoto" class="crop-box"
                        :style="{
                          left: (cropX / 475 * 100) + '%',
                          top: (cropY / 520 * 100) + '%',
                          width: (cropW / 475 * 100) + '%',
                          height: (cropH / 520 * 100) + '%'
                        }"
                        @mousedown.prevent="startCropDrag"
                        @touchstart.prevent="startCropDrag">
                      </div>
                    </div>
                  </div>

                  <div align="center" v-if="isCameraOpen && !isLoading" class="camera-shoot">
                    <v-btn :ripple="false" height="40px" elevation="0" outlined style="border: 1px solid #000 !important" rounded block class="text-none mt-3" @click="takePhoto">
                      <div v-if="isPhotoTaken && isCameraOpen">Retry</div>
                      <div v-else>Capture</div>
                    </v-btn>
                  </div>
                  <div align="center" v-if="isPhotoTaken && !isCameraOpen" class="camera-shoot">
                    <v-btn :ripple="false" height="40px" elevation="0" outlined style="border: 1px solid #000 !important" rounded block class="text-none mt-3" @click="resetUpload">
                      <div>Change Photo</div>
                    </v-btn>
                  </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn height="40px" elevation="0" color="black white--text " rounded block :loading="mobileLoader"
                  @click="checkKraandsentOTP">
                  <span class="text-none px-8">Submit</span>
                </v-btn>
              </v-card-actions>
            </v-form>
          </div>
          <div v-if="verifyotp">
            <v-form ref="formm">
              <v-card-title style="font-size: 16px">
                Verify Your new number
                <v-spacer></v-spacer>
                <v-btn icon @click="closeBtn" v-if="src !== 'mobileapp'">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <p class="ma-0 pa-0" style="font-weight: 499">Mobile number <span style="color: red">*</span></p>
                <v-text-field class="pa-0" readonly hide-spin-buttons v-model="usernewmobile">
                  <template #prepend-inner>
                    <div style="width: 30px">
                      <v-img class="mt-1" max-height="16" max-width="16" src="@/assets/mobile-phone.svg" />
                    </div>
                  </template>
                </v-text-field>
                <p class="ma-0 pa-0" style="font-weight: 499">Enter 4 digit OTP sent to mobile no.<span
                    style="color: red">*</span></p>
                <v-text-field class="pa-0" required type="number" hide-spin-buttons pattern="\d*" maxlength="4"
                  :rules="otpRules" placeholder="00-00" v-model="userOtp">
                  <template #prepend-inner>
                    <div style="width: 30px">
                      <v-img class="mt-1" max-height="16" max-width="16" src="@/assets/mobile-chat.svg" />
                    </div>
                  </template>
                </v-text-field>
                <!-- <p class="ma-0 pa-0">OTP</p>
                                <v-otp-input
                length="4" plain style="height:40px"
              ></v-otp-input> -->
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn elevation="0"
            color="black white--text px-8 "
            rounded
              @click="editdialog = false"
            >
              Close
            </v-btn> -->
                <v-btn height="40px" elevation="0" color="black white--text" rounded block :loading="mobileLoader"
                  @click="otpButtonClicked">
                  <span class="text-none px-8">Submit</span>
                </v-btn>
              </v-card-actions>
            </v-form>
          </div>
          <div v-if="requestotpemail">
            <v-form ref="formemailreq">
              <v-card-title style="font-size: 16px"
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-title font-weight-bold' : ''">
                Email change request <v-spacer></v-spacer>
                <v-btn icon @click="closeBtn" v-if="src !== 'mobileapp'">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <p class="ma-0 pa-0 font-weight-medium txt-666"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Old email id</p>

                <v-text-field class="pa-0" readonly v-model="profileData.CLIENT_ID_MAIL"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''"></v-text-field>
                <p class="ma-0 pa-0" style="font-weight: 499"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">New email id <span
                    style="color: red">*</span></p>

                <v-text-field class="pa-0" required @keyup="usercopytest" :rules="emailRules"
                  placeholder="Enter New email" v-model="usernewemail"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''">
                  <template #prepend-inner>
                    <div style="width: 30px">
                      <v-img class="mt-1" max-height="16" max-width="16" src="@/assets/mail-box.svg" />
                    </div>
                  </template>
                </v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn elevation="0"
            color="black white--text px-8 "
            rounded
              @click="editdialog = false"
            >
              Close
            </v-btn> -->
                <v-footer fixed color="white" v-if="$vuetify.breakpoint.xsOnly">
                  <v-btn height="40px" elevation="0" color="black white--text " rounded block :loading="emailLoader"
                    @click="sendButtonClicked"
                    :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 d-flex mb-3' : ''">
                    <span class="text-none px-8">Submit</span>
                  </v-btn>
                </v-footer>
                <v-btn height="40px" elevation="0" class="d-none d-sm-block d-md-block" color="black white--text "
                  rounded block :loading="emailLoader" @click="sendButtonClicked"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">
                  <span class="text-none px-8">Submit</span>
                </v-btn>
              </v-card-actions>
            </v-form>
          </div>
          <div v-if="verifyotpemail">
            <v-form ref="formemailveri">
              <v-card-title style="font-size: 16px">
                Verify Your new email
                <v-spacer></v-spacer>
                <v-btn icon @click="closeBtn" v-if="src !== 'mobileapp'">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <p class="ma-0 pa-0" style="font-weight: 499">New email id</p>
                <v-text-field class="pa-0" readonly v-model="usernewemail">
                  <template #prepend-inner>
                    <div style="width: 30px">
                      <v-img class="mt-1" max-height="16" max-width="16" src="@/assets/mail-box.svg" />
                    </div>
                  </template>
                </v-text-field>

                <p class="ma-0 pa-0" style="font-weight: 499">
                  Enter 4 digit OTP sent to your e-mail.
                  <span style="color: red">*</span>
                </p>
                <v-text-field class="pa-0" required type="number" hide-spin-buttons pattern="\d*" maxlength="4"
                  :rules="otpRules" placeholder="00-00" v-model="useremailOtp">
                  <template #prepend-inner>
                    <div style="width: 30px">
                      <v-img class="mt-1" max-height="16" max-width="16" src="@/assets/mobile-chat.svg" />
                    </div>
                  </template>
                </v-text-field>
                <!-- <p class="ma-0 pa-0">OTP</p>
                                <v-otp-input
    length="4" plain style="height:40px"
  ></v-otp-input> -->
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn elevation="0"
            color="black white--text px-8 "
            rounded
              @click="editdialog = false"
            >
              Close
            </v-btn> -->
                <v-btn height="40px" elevation="0" color="black white--text " rounded block :loading="emailLoader"
                  @click="otpButtonClicked">
                  <span class="text-none px-8">Submit</span>
                </v-btn>
              </v-card-actions>
            </v-form>
          </div>
          <div v-if="adresschange">
            <v-card-title style="font-size: 16px"
              :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-title font-weight-bold' : ''">
              Address change request <v-spacer></v-spacer>
              <v-btn icon @click="closeBtn" v-if="src !== 'mobileapp'">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <div class="mx-4 mb-4" v-if="adressOptions">
              <v-btn height="40px" color="#000" elevation="0" class="white--text text-none" block rounded
                @click="kraImageCheck" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 mt-4 mb-6' : ''">
                Aadhar
                (Digilocker) </v-btn>
            </div>

            <!-- <div class="mx-4 mb-2" v-if="adressOptions">
              <v-btn height="40px" elevation="0" outlined style="border: 1px solid #000 !important" rounded
                class="text-none" block @click="(adressOptions = false), (manual = true)"
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''"> Type manually </v-btn>
            </div> -->

            <v-form v-if="manual" ref="formadress" :class="$vuetify.breakpoint.smAndDown ? 'pb-6' : ''">
              <v-card-text>
                <p class="ma-0 pa-0 font-weight-medium txt-666"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Old Address</p>

                <v-text-field readonly class="pa-0" v-model="profileData.CL_RESI_ADD1"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''"></v-text-field>
                <p class="ma-0 pa-0 font-weight-bold"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">
                  New
                  Address <span style="color: red">*</span></p>

                <v-text-field class="pa-0" required :rules="addressRules" placeholder="New Address"
                  v-model="usernewAdress"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version pb-3' : ''"></v-text-field>

                <!-- PINCODE FOR MANUAL ADDRESS -->
                <v-row no-gutters>
                  <v-col>
                    <v-list-item class="pa-0 pr-2">
                      <v-list-item-content class="pa-0">
                        <p class="ma-0 pa-0 font-weight-bold"
                          :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 p' : ''">Pincode <span
                            style="color: red">*</span></p>
                        <v-text-field class="pa-0" hide-spin-buttons type="number" placeholder="PINCODE"
                          :loading="pinLoader" v-model="pincodeAddress" @keyup="pincodeFetch()" :rules="nomineeField"
                          :class="$vuetify.breakpoint.smAndDown ? 'mobile-version pb-3' : ''"></v-text-field>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item class="pa-0 pr-2">
                      <v-list-item-content class="pa-0">
                        <p class="ma-0 pa-0 font-weight-bold"
                          :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">State <span
                            style="color: red">*</span></p>

                        <v-text-field class="pa-0" :rules="nomineeField" placeholder="STATE" v-model="stateAddress"
                          :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''"></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col>
                    <v-list-item class="pa-0 pl-2">
                      <v-list-item-content class="pa-0">
                        <p class="ma-0 pa-0 font-weight-bold"
                          :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">District <span
                            style="color: red">*</span></p>

                        <v-text-field class="pa-0" :rules="nomineeField" placeholder="DISTRICT" v-model="distAddress"
                          :class="$vuetify.breakpoint.smAndDown ? 'mobile-version pb-3' : ''"></v-text-field>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item class="pa-0 pl-2">
                      <v-list-item-content class="pa-0">
                        <p class="ma-0 pa-0 font-weight-bold"
                          :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Country <span
                            style="color: red">*</span></p>

                        <v-text-field class="pa-0" :rules="nomineeField" placeholder="COUNTRY" v-model="countryAddress"
                          :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''"></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>

                <p class="ma-0 pa-0 font-weight-bold"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 pt-3' : ''">Proof type <span
                    style="color: red">*</span></p>

                <v-select class="pa-0" :items="prooftype" :rules="nomineeField" v-model="proofTypes"
                  placeholder="Proof type"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version pb-3' : ''"></v-select>

                <p class="ma-0 pa-0 font-weight-bold pb-2"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 pb-2' : ''">Upload proof <span
                    style="color: red">*</span></p>
                <v-card color="rgba(246, 247, 247, 0.5)" @ondragover="onChange"
                  :class="dragging ? 'dropAreaDragging' : ''" @dragenter="dragging = true" @dragend="dragging = false"
                  @dragleave="dragging = false" class="fileupload elevation-0 rounded-lg text-center pa-2"
                  style="border: 1px dashed #d0d3d6">
                  <!-- <v-card class="pa-3" @click="openFileInput()"> -->
                  <!-- <div align="center"> -->
                  <!-- <p style="font-weight:499;font-size:15px;color:#0037B7"  class="ma-0"> Click here to upload</p> -->
                  <!-- <p>You can drop your last 6 months Bank statement here to be uploaded</p> -->
                  <div class="innerfilup">
                    <!-- <img class="mb-2" src="@/assets/file drop.svg" width="48px" /> -->
                    <p class="font-weight-bold fs-18" style="color: #0037b7 !important ; margin-bottom: 0em">Upload your
                      Address Proof</p>
                    <p class="mb-1 txt-666 font-weight-regular" style="line-height: 18px">Select a file or drag it into
                      the
                      box below.
                    </p>
                  </div>
                  <label for="fileUpload" class="custom-upload-btn"><v-icon small class="mr-1"
                      color="white">mdi-upload</v-icon>Choose File</label>
                  <input type="file" id="fileUpload" accept=".pdf" name="items[]" required multiple @change="onChange"
                    style="display: none" />

                  <!-- <div v-if="panFile" class="mt-4 ml-2">
                  <v-icon color="green" class="mr-1" small>mdi-check</v-icon>
                  <span class="grey--text caption">{{ panimagedata.name }}</span>
                </div>
                <div v-else class="mb-4 ml-4 grey--text caption">No file chosen</div> -->
                  <div class=" grey--text text--darken-2 ml-1 mt-3 font-weight-regular"
                    style="font-size:13px!important;">
                    Accepted formats: .pdf</div>
                  <!-- </div> -->
                </v-card>
                <div v-if="panFile" class="mt-4 ml-2">
                  <v-icon color="green" class="mr-1 pb-1" small>mdi-check</v-icon>
                  <span class="grey--text text--darken-3" style="font-size:14px!important;">{{ panimagedata.name
                  }}</span>
                </div>
                <!-- <div v-if="panFile">
                <p>
                  <span class="txt-666">File names</span> :
                  <b>{{ panimagedata.name }}</b>
                </p>
              </div> -->
                <!-- <div class="text-right mb-2"> -->
                <!-- <v-card width="100%" class="elevation-0 mb-16 mb-md-0" style="transform: scaleX(-1) !important">
                                <iframe style="border: none; border-radius: 8px;" :src="panimage" width="100%"
                                    height="240"></iframe>
                            </v-card> -->

                <!-- </div> -->
                <!-- <v-file-input
                prepend-icon=""
                prepend-inner-icon="mdi-paperclip"
                class="pa-0"
                :rules="nomineeField"
                v-model="adressproffdoc"
                accept="image/*,.pdf"
                placeholder="Upload Proof"
              ></v-file-input> -->
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn elevation="0"
            color="black white--text px-8 "
            rounded
              @click="editdialog = false"
            >
              Close
            </v-btn> -->
                <v-btn height="40px" elevation="0" color="black white--text" rounded :loading="addressLoader" block
                  @click="kraImageCheck" class="d-none d-sm-block d-md-block">
                  <span class="text-none px-8">Submit</span>
                </v-btn>
                <v-footer fixed color="white" v-if="$vuetify.breakpoint.xsOnly">
                  <v-btn height="40px" elevation="0" color="black white--text " rounded :loading="addressLoader" block
                    @click="kraImageCheck"
                    :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 d-flex mb-3' : ''">
                    <span class="text-none px-8">Submit</span>
                  </v-btn>
                </v-footer>
              </v-card-actions>
            </v-form>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="esignconfirmation" persistent min-width="380" :fullscreen="$vuetify.breakpoint.smAndDown"
        :max-width="addNewSeg ? '500' : '420'">
        <v-card class="rounded-lg px-2 px-md-2">
          <v-card-title class="pr-2">E-Sign Is Pending ! <v-spacer></v-spacer>
            <v-btn icon @click="esignconfirmation = false, diaesigntype = ''" v-if="src !== 'mobileapp'">
              <v-icon>mdi-close</v-icon>
            </v-btn></v-card-title>
          <v-card-text class="font-weight-bold">
            Your {{ diaesigntype == "mobile" ? "Mobile" : diaesigntype == "email" ? "Email" : diaesigntype == "address"
              ?
              "Address" : "" }} Change request is not yet Completed,

          </v-card-text>
          <v-card-actions class="pb-4">
            <!-- <v-btn
                height="40px"
                block
                color="red darken-1 text-none"
                text
                @click="deleteBankapi"
              >
                Delete
              </v-btn> -->
            <v-btn v-if="diaesigntype == 'mobile'" elevation="0" color="black white--text" rounded block
              @click="digioEsign(mobStatus.mobile_file_id, mobStatus.mob_client_email.toUpperCase(), mobStatus.mob_session), (editType = 'mobile_change'), diaesigntype = ''">
              <span class="text-none"> Click here E-sign</span>
            </v-btn>

            <v-btn v-if="diaesigntype == 'email'" elevation="0" color="black white--text" rounded block
              @click="digioEsign(mobStatus.email_file_id, mobStatus.email_new_email_id.toLowerCase(), mobStatus.email_session), (editType = 'email_change'), diaesigntype = ''">
              <span class="text-none"> Click here E-sign</span>
            </v-btn>
            <v-btn v-if="diaesigntype == 'address'" elevation="0" color="black white--text" rounded block
              @click="(editType = 'address_change'), digioEsign(mobStatus.address_file_id, mobStatus.address_client_email.toLowerCase(), mobStatus.address_session), diaesigntype = ''">
              <span class="text-none"> Click here E-sign</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div id="mobile-app" class="ma-lg-10 ml-lg-10 ma-md-10 ml-md-10 d-md-none">
      <!-- <div id="app" class="web-camera-container">
  <div class="camera-button">
      <v-btn type="button" class="button is-rounded" :class="{ 'is-primary' : !isCameraOpen, 'is-danger' : isCameraOpen}" @click="toggleCamera">
        <span v-if="!isCameraOpen">Open Camera</span>
        <span v-else>Close Camera</span>
      </v-btn>
  </div>
  
  <div v-show="isCameraOpen && isLoading" class="camera-loading">

  </div>
  
  <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
    
    <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
      
    <video v-show="!isPhotoTaken" ref="camera" :width="450" :height="337.5" autoplay></video>
    
    <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="450" :height="337.5"></canvas>
  </div>
  
  <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
    <button type="button" class="button" @click="takePhoto">
      <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png">
    </button>
  </div>
  
  <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
    <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button" @click="downloadImage">
      Download
    </a>
  </div>
</div> -->
      <div class="px-4">
        <div class="py-md-7 d-block d-md-none"></div>
        <div class="px-md-3">
          <v-list-item class="pl-0 pl-md-1">
            <v-list-item-content>
              <v-list-item-title class="text-start"
                style="color: #000000; font-size: 20px; font-weight: 559; line-height: 24px; letter-spacing: -1px"
                :class="$vuetify.breakpoint.smAndDown ? 'title-align mobile-version-title' : ''"> Profile
                Details</v-list-item-title>
              <v-list-item-subtitle class="text-start pt-1"
                style="color: #666666; font-size: 12px; font-weight: 469; line-height: 14px; white-space: normal; word-break: break-word;"
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-subtitle sub-align' : ''">These details are used
                for all communication related to your account. </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <!-- <p class="font-weight-bold fs-22 mb-0">Profile Details 
          
        </p>
        <p class="subtitle-2 txt-666">
          These details are used for all communication related to your account.
        </p> -->
        </div>
        <v-divider></v-divider>
        <v-card class="py-md-6 px-md-3 mt-6 mb-md-6" :outlined="$vuetify.breakpoint.smAndDown ? false : true"
          elevation="0" width="100%">
          <!-- <p class="subtitle-1 txt-666 font-weight-medium"
            :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 sub-align' : ''">Personal Details</p> -->

          <v-row class="align-start"> <!-- Changed from align-center to align-start -->
            <v-col cols="4" class="d-flex align-start"> <!-- Added d-flex align-start -->
              <p class="grey--text text--darken-2 mb-3">Name</p> <!-- Added padding-top and mb-0 -->
            </v-col>
            <v-col cols="8" class="d-flex justify-end align-start mb-3"> <!-- Added align-start -->
              <p class="text-right mb-0" style="word-wrap: break-word; overflow-wrap: break-word; line-height: 1.4;">
                {{ profileData.Pan_Name }}
              </p>
            </v-col>
          </v-row>

          <v-row class="align-center mt-n4">
            <!-- <v-col cols="12" sm="6" md="4"> -->
            <v-col cols="4">
              <p class="grey--text text--darken-2">Birth Date</p>
            </v-col>
            <v-col cols="8" class="d-flex justify-end">
              <p>{{ profileData.BIRTH_DATE }}</p>
            </v-col>
          </v-row>
          <v-row class="align-center mt-n4">
            <!-- <v-col cols="12" sm="6" md="4"> -->
            <v-col cols="6">
              <p class="grey--text text--darken-2">Martial Status</p>
            </v-col>
            <v-col cols="6" class="d-flex justify-end">
              <p>{{ profileData.Marital_status }}</p>
            </v-col>
          </v-row>
          <v-row class="align-center mt-n4">
            <!-- <v-col cols="12" sm="6" md="4"> -->
            <v-col cols="4">
              <p class="grey--text text--darken-2">PAN</p>
            </v-col>
            <v-col cols="8" class="d-flex justify-end">
              <p>{{ `*******${hashpan}` }}</p>
            </v-col>
          </v-row>
          <v-row class="align-start mt-n4">
            <!-- <v-col cols="12" sm="6" md="4"> -->
            <v-col cols="6" class="d-flex align-center">
              <p class="grey--text text--darken-2">Email</p>
              <!-- </v-col> -->
              <!-- <v-col cols="4"> -->

              <!-- ------------------------------------------- -->
              <!-- <div v-if="accountstatus != 'client_close'">
                <v-btn @click="mobileEdit('email')" class=" icon ml-6 mt-n5 px-4" v-if="!emailDisable" elevation="0"
                  text small :disabled="accountstatus == 'client_close' || !last7days"
                  :style="{ background: !last7days ? 'grey' : '0' }" height='26px' width='2px'
                  style="border-radius:8px !important;border-color: #BDBDBD;margin-left:26px !important;">
                  <span :style="$vuetify.breakpoint.smAndDown ? 'color: #000; font-size: 12px;' : ''"><v-icon
                      class="grey--text text--darken-2" small>mdi-pencil</v-icon></span>
                </v-btn>
              </div> -->

              <div v-if="accountstatus != 'client_close'">
                <v-tooltip bottom open-on-click v-if="(!emailDisable && !last7days) || profileData.CATEGORY != 'I'">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-btn class="icon ml-6 mt-n5 px-4" elevation="0" text small height="26px" width="2px" :style="{
                        background: 'grey',
                        cursor: 'not-allowed',
                        pointerEvents: 'auto',
                        borderRadius: '8px',
                        borderColor: '#BDBDBD',
                        marginLeft: '26px',
                      }" @click.stop>
                        <span :style="$vuetify.breakpoint.smAndDown
                          ? 'color: #000; font-size: 12px; opacity: 0.5'
                          : 'opacity: 0.5'">
                          <v-icon class="grey--text text--darken-2" small>mdi-pencil</v-icon>
                        </span>
                      </v-btn>
                    </div>
                  </template>
                  <span>
                    {{ profileData.CATEGORY != 'I' ? 'Non-individual accounts can’t modify data here. Please contact support at (+91) 93 8010 8010 for help.' : 'Modification request not allowed within 7 days of activation' }}
                  </span>
                </v-tooltip>

                <v-btn v-else-if="!emailDisable && last7days" @click="mobileEdit('email')" class="icon ml-6 mt-n5 px-4"
                  :disabled="profileData.CATEGORY != 'I' || rekyc_status == 'Yes'"
                  elevation="0" text small height="26px" width="2px" :style="{
                    background: '0',
                    borderRadius: '8px',
                    borderColor: '#BDBDBD',
                    marginLeft: '26px',
                  }">
                  <span :style="$vuetify.breakpoint.smAndDown ? 'color: #000; font-size: 12px;' : ''">
                    <v-icon class="grey--text text--darken-2" small>mdi-pencil</v-icon>
                  </span>
                </v-btn>
              </div>


              <div v-if="accountstatus == 'client_close'">
                <v-tooltip :disabled="!last7days" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-btn disabled class="rounded icon ml-6 mt-n5 px-4" elevation="0" text small height='26px'
                        width='2px'
                        style="border-radius:8px !important;border-color: #BDBDBD;margin-left:26px !important;"> <span
                          :style="$vuetify.breakpoint.smAndDown ? 'color: #000; font-size: 12px' : ''"><v-icon
                            class="grey--text text--darken-2" small>mdi-pencil</v-icon> </span></v-btn>
                    </span>
                  </template>
                  <span>Your trading account is closed</span>
                </v-tooltip>
              </div>
            </v-col>
            <v-col cols="6" class="d-flex justify-end align-start">
              <p class="text-right mb-0"
                style="word-wrap: break-word; overflow-wrap: break-word; word-break: break-all; line-height: 1.4;">
                {{ profileData.CLIENT_ID_MAIL }}
              </p>
            </v-col>
          </v-row>
          <v-row class="align-center mt-n4">
            <!-- <v-col cols="12" sm="6" md="4"> -->
            <v-col cols="6" class="d-flex align-center">
              <p class="grey--text text--darken-2">Mobile</p>
              <!-- </v-col> -->
              <!-- <v-col cols="4"> -->

              <!-- ------------------------------------- -->
              <!-- <div v-if="accountstatus != 'client_close'">
                <v-btn @click="mobileEdit('mobile')" class="rounded icon ml-4 mt-n5 px-4 icon" v-if="!mobileDisable"
                  elevation="0" text small :disabled="accountstatus == 'client_close' || !last7days"
                  :style="{ background: !last7days ? 'grey' : '0' }" height='26px' width='2px'
                  style="border-radius:8px !important; border-color: #BDBDBD;margin-left:18px !important;">
                  <span :style="$vuetify.breakpoint.smAndDown ? 'color: #000; font-size: 12px' : ''"><v-icon
                      class="grey--text text--darken-2" small>mdi-pencil</v-icon></span>
                </v-btn>
              </div> -->

              <div v-if="accountstatus != 'client_close'">
                <v-tooltip bottom open-on-click v-if="(!mobileDisable && !last7days) || profileData.CATEGORY != 'I'">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-btn class="rounded icon ml-4 mt-n5 px-4" elevation="0" text small height="26px" width="2px"
                        :style="{
                          background: 'grey',
                          cursor: 'not-allowed',
                          pointerEvents: 'auto',
                          borderRadius: '8px',
                          borderColor: '#BDBDBD',
                          marginLeft: '18px',
                        }" @click.stop>
                        <span :style="$vuetify.breakpoint.smAndDown
                          ? 'color: #000; font-size: 12px; opacity: 0.5'
                          : 'opacity: 0.5'">
                          <v-icon class="grey--text text--darken-2" small>mdi-pencil</v-icon>
                        </span>
                      </v-btn>
                    </div>
                  </template>
                  <span>
                    {{ profileData.CATEGORY != 'I' ? 'Non-individual accounts can’t modify data here. Please contact support at (+91) 93 8010 8010 for help.' : 'Modification request not allowed within 7 days of activation' }}
                  </span>
                </v-tooltip>

                <v-btn v-else-if="!mobileDisable && last7days" @click="mobileEdit('mobile')"
                  :disabled="profileData.CATEGORY != 'I' || rekyc_status == 'Yes'"
                  class="rounded icon ml-4 mt-n5 px-4" elevation="0" text small height="26px" width="2px" :style="{
                    background: '0',
                    borderRadius: '8px',
                    borderColor: '#BDBDBD',
                    marginLeft: '18px',
                  }">
                  <span :style="$vuetify.breakpoint.smAndDown ? 'color: #000; font-size: 12px' : ''">
                    <v-icon class="grey--text text--darken-2" small>mdi-pencil</v-icon>
                  </span>
                </v-btn>
              </div>



              <div v-if="accountstatus == 'client_close'">
                <v-tooltip :disabled="!last7days" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-btn disabled class="rounded icon ml-4 mt-n5 px-4 icon" elevation="0" text small height='26px'
                        width='2px'
                        style="border-radius:8px !important; border-color: #BDBDBD;margin-left:18px !important;"><span
                          :style="$vuetify.breakpoint.smAndDown ? 'color: #000; font-size: 12px' : ''"><v-icon
                            class="grey--text text--darken-2" small>mdi-pencil</v-icon></span> </v-btn>
                    </span>
                  </template>
                  <span>Your trading account is closed</span>
                </v-tooltip>
              </div>
            </v-col>
            <v-col cols="6" class="d-flex justify-end">
              <p>{{ profileData.MOBILE_NO }}</p>
            </v-col>
          </v-row>
          <v-row class="align-start mt-n4">
            <!-- <v-col cols="12" sm="6" md="4"> -->
            <v-col cols="4" class="d-flex align-center">
              <p class="grey--text text--darken-2">Address</p>
              <!-- </v-col> -->
              <!-- <v-col cols="1" class="d-flex mt-2 justify-start align-end"> -->

              <!-- ---------------------- -->
              <!-- <div v-if="accountstatus != 'client_close'">
                <v-btn @click="mobileEdit('address')" class="rounded icon ml-2 mt-n5 px-4" v-if="!addressDisable"
                  height="26px" width="2px" elevation="0" text small
                  :disabled="accountstatus == 'client_close' || !atve_sts || !last7days" :style="{
                    borderRadius: '8px',
                    borderColor: '#BDBDBD',
                  }">
                  <span :style="{
                    color: $vuetify.breakpoint.smAndDown ? '#000' : '',
                    fontSize: $vuetify.breakpoint.smAndDown ? '12px' : ''
                  }">
                    <v-icon class="grey--text text--darken-2" small>mdi-pencil</v-icon>
                  </span>
                </v-btn>
              </div> -->


              <div v-if="accountstatus != 'client_close'">
                <v-tooltip bottom open-on-click v-if="(!addressDisable && !atve_sts) || profileData.CATEGORY != 'I'">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-btn class="rounded icon ml-2 mt-n5 px-4" height="26px" width="2px" elevation="0" text small
                        @click.stop :style="{
                          borderRadius: '8px',
                          borderColor: '#BDBDBD',
                          backgroundColor: '#f5f5f5',
                          cursor: 'not-allowed',
                          pointerEvents: 'auto',
                        }">
                        <span :style="{
                          color: $vuetify.breakpoint.smAndDown ? '#000' : '',
                          fontSize: $vuetify.breakpoint.smAndDown ? '12px' : '',
                          opacity: 0.5,
                        }">
                          <v-icon class="grey--text text--darken-2" small>
                            mdi-pencil
                          </v-icon>
                        </span>
                      </v-btn>
                    </div>
                  </template>

                  <span>
                    {{ profileData.CATEGORY != 'I' ? 'Non-individual accounts can’t modify data here. Please contact support at (+91) 93 8010 8010 for help.' : 'Modification not allowed for inactive client codes. Please reactivate the account.' }}
                  </span>
                </v-tooltip>


                <v-btn v-else @click="mobileEdit('address')" :disabled="profileData.CATEGORY != 'I'" class="rounded icon ml-2 mt-n5 px-4" height="26px"
                  width="2px" elevation="0" text small :style="{
                    borderRadius: '8px',
                    borderColor: '#BDBDBD',
                  }">
                  <span :style="{
                    color: $vuetify.breakpoint.smAndDown ? '#000' : '',
                    fontSize: $vuetify.breakpoint.smAndDown ? '12px' : '',
                  }">
                    <v-icon class="grey--text text--darken-2" small>mdi-pencil</v-icon>
                  </span>
                </v-btn>
              </div>


              <div v-if="accountstatus == 'client_close'">
                <v-tooltip :disabled="!atve_sts" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-btn disabled class="rounded icon ml-2 mt-n5 px-4" height='26px' width='2px' elevation="0" small
                        text style="border-radius:8px !important;border-color: #BDBDBD;">
                        <span :style="$vuetify.breakpoint.smAndDown ? 'color: #000; font-size: 12px' : ''"><v-icon
                            class="grey--text text--darken-2" small>mdi-pencil</v-icon></span>
                      </v-btn>
                    </span>
                  </template>
                  <span>Your trading account is closed</span>
                </v-tooltip>
              </div>
            </v-col>
            <v-col cols="8" class="d-flex align-start text-right justify-end" style="line-height: 1.4;">
              <p>{{ profileData.CL_RESI_ADD1 }}</p>
            </v-col>
            <!-- <v-col cols="1" class="mt-n4 ml-n2"> -->

            <!-- </v-col> -->
          </v-row>

          <v-card rounded="lg" v-if="mobStatus.mobile_status == 'e-signed pending'" color="#FCEFD4" elevation="0"
            class="">
            <div class="px-2 py-1">
              <p style="font-size: 10.5px;  font-weight: 459; margin: 0; display: inline; color: #666666"
                class="d-none d-md-block" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">
                Your Mobile Change request is not yet Completed,<span style="color: #0037b7; cursor: pointer"
                  @click="digioEsign(mobStatus.mobile_file_id, mobStatus.mob_client_email.toUpperCase(), mobStatus.mob_session), (editType = 'mobile_change')">
                  Click here esign</span>
                <span @click="(editType = 'mobile_change'), (fileide = mobStatus.mobile_file_id), (confirmation = true)"
                  class="mt-1 mr-2 " style="color: red; cursor: pointer; float: right">Cancel request</span>
              </p>
              <div class="mt-1  d-md-none">
                <p style="font-size: 10.5px;  font-weight: 459; margin: 0; display: inline; color: #666666"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Your Mobile
                  Change
                  request is not yet Completed,</p>
                <div class="d-flex">
                  <span style="color: #0037b7; cursor: pointer"
                    @click="digioEsign(mobStatus.mobile_file_id, mobStatus.mob_client_email.toUpperCase(), mobStatus.mob_session), (editType = 'mobile_change')">
                    Click here esign</span>
                  <span
                    @click="(editType = 'mobile_change'), (fileide = mobStatus.mobile_file_id), (confirmation = true)"
                    class="mt-1 mr-2 ml-auto" style="color: red; cursor: pointer; float: right">Cancel request</span>
                </div>
              </div>
            </div>
          </v-card>
          <v-card rounded="lg" v-if="mobStatus.mobile_status == 'e-signed completed'" color="#FCEFD4" elevation="0"
            class="">
            <div class="px-2 py-1">
              <p style="font-size: 10.5px; font-weight: 459; margin: 0; display: inline; color: #666666"
                :class="$vuetify.breakpoint.smAndDown ? 'fs-14' : ''">
                Your Mobile Change request is in process
                <!-- <span style="color: #0037B7;cursor: pointer;"> Click here esign</span> -->
              </p>
            </div>
          </v-card>
          <v-card rounded="lg" v-if="mobStatus.email_status == 'e-signed pending'" color="#FCEFD4" elevation="0"
            class="mt-4">
            <div class="px-2 py-1">
              <p style="font-size: 10.5px; font-weight: 459; margin: 0; display: inline; color: #666666"
                class="d-none d-md-block" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">
                Your Email Change request is not yet Completed,<span style="color: #0037b7; cursor: pointer"
                  @click="digioEsign(mobStatus.email_file_id, mobStatus.email_new_email_id.toLowerCase(), mobStatus.email_session), (editType = 'email_change')">
                  Click here esign</span>
                <span @click="(editType = 'email_change'), (fileide = mobStatus.email_file_id), (confirmation = true)"
                  class="mt-1 mr-2" style="color: red; cursor: pointer; float: right">Cancel request</span>
              </p>

              <div class="d-md-none">
                <p style="font-size: 10.5px;  font-weight: 459; margin: 0; display: inline; color: #666666"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub' : ''"> Your Email
                  Change
                  request is not yet Completed,</p>
                <div class="d-flex">
                  <span style="color: #0037b7; cursor: pointer"
                    @click="digioEsign(mobStatus.email_file_id, mobStatus.email_new_email_id.toLowerCase(), mobStatus.email_session), (editType = 'email_change')">
                    Click here esign</span>

                  <span @click="(editType = 'email_change'), (fileide = mobStatus.email_file_id), (confirmation = true)"
                    class="mt-0 mr-2 ml-auto" style="color: red; cursor: pointer; float: right">Cancel request</span>

                </div>

              </div>



              <!-- <span
                @click="editType = 'email_change', fileide = mobStatus.email_file_id, confirmation = true"
                class="mt-1 mr-2 d-none d-sm-flex d-sm-flex d-md-flex d-lg-none d-xl-none" style="color: red;cursor: pointer;float:right">Cancel request</span> -->
            </div>
          </v-card>
          <v-card rounded="lg" v-if="mobStatus.email_status == 'e-signed completed'" color="#FCEFD4" elevation="0"
            class="mt-4">
            <div class="px-2 py-1">
              <p style="font-size: 10.5px; font-weight: 459; margin: 0; display: inline; color: #666666"
                :class="$vuetify.breakpoint.smAndDown ? 'fs-14' : ''">
                Your Email Change request is in process
                <!-- <span style="color: #0037B7;cursor: pointer;"> Click here esign</span> -->
              </p>
            </div>
          </v-card>
          <v-card rounded="lg" v-if="mobStatus.address_status == 'e-signed pending'" color="#FCEFD4" elevation="0"
            class="mt-4">
            <div class="px-2 py-1">
              <p style="font-size: 10.5px; font-weight: 459; margin: 0; display: inline; color: #666666"
                class="d-none d-md-block" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">
                Your Address Change request is not yet Completed,<span style="color: #0037b7; cursor: pointer"
                  @click="(editType = 'address_change'), digioEsign(mobStatus.address_file_id, mobStatus.address_client_email.toLowerCase(), mobStatus.address_session)">
                  Click here esign</span><span
                  @click="(editType = 'address_change'), (fileide = mobStatus.address_file_id), (confirmation = true)"
                  class="mt-1 mr-2" style="color: red; cursor: pointer; float: right">Cancel request</span>
              </p>

              <div class="d-md-none">
                <p style="font-size: 10.5px; font-weight: 459; margin: 0; display: inline; color: #666666"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub' : ''">
                  Your Address Change request is not yet Completed,</p>
                <div class="d-flex">
                  <span style="color: #0037b7; cursor: pointer"
                    @click="(editType = 'address_change'), digioEsign(mobStatus.address_file_id, mobStatus.address_client_email.toLowerCase(), mobStatus.address_session)">
                    Click here esign</span>
                  <span
                    @click="(editType = 'address_change'), (fileide = mobStatus.address_file_id), (confirmation = true)"
                    class="mr-2 ml-auto" style="color: red; cursor: pointer; float: right">Cancel request</span>
                </div>
              </div>



            </div>
          </v-card>
          <v-card rounded="lg" v-if="mobStatus.address_status == 'e-signed completed'" color="#FCEFD4" elevation="0"
            class="mt-4">
            <div class="px-2 py-1">
              <p style="font-size: 10.5px; font-weight: 459; margin: 0; display: inline; color: #666666"
                :class="$vuetify.breakpoint.smAndDown ? 'fs-14' : ''">
                Your Address Change request is in process
                <!-- <span style="color: #0037B7;cursor: pointer;"> Click here esign</span> -->
              </p>
            </div>
          </v-card>
        </v-card>

        <!-- <v-card 
                class="py-md-6 mb-md-6 d-md-none"
                elevation="0"
                width="100%"
              >
                <p class="subtitle-1 txt-666 font-weight-medium">
                  Personal Details
                </p>

                <v-row no-glutters>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                       
                      readonly
                      :loading="profileLoader"
                      v-model="profileData.CLIENT_NAME"
                      append-icon=""
                      label="NAME"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                       
                      readonly
                      :loading="profileLoader"
                      :value="`*******${hashpan}`"
                      append-icon=""
                      label="PAN NUMbER"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                       
                      :loading="profileLoader"
                      readonly
                      label="EMAIL"
                      :disabled="emailDisable"
                      :append-icon="'mdi-pencil-circle-outline'"
                      v-model="profileData.CLIENT_ID_MAIL"
                    >
                      <template #append>
                        <v-btn @click="mobileEdit('email')" icon small>
                          <img src="@/assets/pen.svg" alt="pen" />
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      id="mobileedit"
                       
                      readonly
                      :disabled="mobileDisable"
                      :loading="profileLoader"
                      v-model="profileData.MOBILE_NO"
                      :append-icon="'mdi-pencil-circle-outline'"
                      label="MOBILE"
                    >
                      <template #append>
                        <v-btn @click="mobileEdit('mobile')" icon small>
                          <img src="@/assets/pen.svg" alt="pen" />
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="8">
                    <v-text-field
                      :loading="profileLoader"
                      readonly
                      :disabled="addressDisable"
                       
                      :append-icon="'mdi-pencil-circle-outline'"
                      label="ADDRESS"
                      v-model="profileData.CL_RESI_ADD1"
                      @click:append="mobileEdit('address')"
                    >
                      <template #append>
                        <v-btn @click="mobileEdit('address')" icon small>
                          <img src="@/assets/pen.svg" alt="pen" />
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>

                
                </v-row>
                <v-card
                  rounded="lg"
                  v-if="mobStatus.mobile_status == 'e-signed pending'"
                  color="#FCEFD4"
                  elevation="0"
                  class=""
                >
                  <div class="px-2 py-1">
                    <p
                      style="
                        font-size: 10.5px;
                        font-weight: 459;
                        margin: 0;
                        display: inline;
                        color: #666666;
                      "
                    >
                      Your Mobile Change request is not yet Completed,<span
                        style="color: #0037b7; cursor: pointer"
                        @click="
                          digioEsign(
                            mobStatus.mobile_file_id,
                            mobStatus.mob_client_email,
                            mobStatus.mob_session
                          ),
                            (editType = 'mobile_change')
                        "
                      >
                        Click here esign</span
                      >
                    </p>
                  </div>
                </v-card>
                <v-card
                  rounded="lg"
                  v-if="mobStatus.mobile_status == 'e-signed completed'"
                  color="#FCEFD4"
                  elevation="0"
                  class=""
                >
                  <div class="px-2 py-1">
                    <p
                      style="
                        font-size: 10.5px;
                        font-weight: 459;
                        margin: 0;
                        display: inline;
                        color: #666666;
                      "
                    >
                      Your Mobile Change request is in process
                    </p>
                  </div>
                </v-card>
                <v-card
                  rounded="lg"
                  v-if="mobStatus.email_status == 'e-signed pending'"
                  color="#FCEFD4"
                  elevation="0"
                  class="mt-4"
                >
                  <div class="px-2 py-1">
                    <p
                      style="
                        font-size: 10.5px;
                        font-weight: 459;
                        margin: 0;
                        display: inline;
                        color: #666666;
                      "
                    >
                      Your Email Change request is not yet Completed,<span
                        style="color: #0037b7; cursor: pointer"
                        @click="
                          digioEsign(
                            mobStatus.email_file_id,
                            mobStatus.email_new_email_id,
                            mobStatus.email_session
                          ),
                            (editType = 'email_change')
                        "
                      >
                        Click here esign</span
                      >
                    </p>
                  </div>
                </v-card>
                <v-card
                  rounded="lg"
                  v-if="mobStatus.email_status == 'e-signed completed'"
                  color="#FCEFD4"
                  elevation="0"
                  class="mt-4"
                >
                  <div class="px-2 py-1">
                    <p
                      style="
                        font-size: 10.5px;
                        font-weight: 459;
                        margin: 0;
                        display: inline;
                        color: #666666;
                      "
                    >
                      Your Email Change request for (
                      {{ this.mobStatus.email_new_email_id }} ) is in process
                    </p>
                  </div>
                </v-card>
                <v-card
                  rounded="lg"
                  v-if="mobStatus.address_status == 'e-signed pending'"
                  color="#FCEFD4"
                  elevation="0"
                  class="mt-4"
                >
                  <div class="px-2 py-1">
                    <p
                      style="
                        font-size: 10.5px;
                        font-weight: 459;
                        margin: 0;
                        display: inline;
                        color: #666666;
                      "
                    >
                      Your Address Change request is not yet Completed,<span
                        style="color: #0037b7; cursor: pointer"
                        @click="
                          (editType = 'address_change'),
                            digioEsign(
                              mobStatus.address_file_id,
                              mobStatus.address_client_email,
                              mobStatus.address_session
                            )
                        "
                      >
                        Click here esign</span
                      >
                    </p>
                  </div>
                </v-card>
                <v-card
                  rounded="lg"
                  v-if="mobStatus.address_status == 'e-signed completed'"
                  color="#FCEFD4"
                  elevation="0"
                  class="mt-4"
                >
                  <div class="px-2 py-1">
                    <p
                      style="
                        font-size: 10.5px;
                        font-weight: 459;
                        margin: 0;
                        display: inline;
                        color: #666666;
                      "
                    >
                      Your Address Change request is in process
                    </p>
                  </div>
                </v-card>
              </v-card> -->
      </div>
      <v-snackbar class="pt-6 pr-md-6 snakbar-sty rounded-pill" elevation="0" transition="slide-x-reverse-transition"
        v-model="snackbar" :timeout="4000" :value="true" color="warning" text-color="white">
        <v-icon class="mr-2" color="white">mdi-alert-outline</v-icon>
        Session <strong>{{ txt }}</strong> Kindly Login again.
        <v-icon @click="snackbar = false" class="float-right" color="white">mdi-close-circle</v-icon>
      </v-snackbar>
      <v-snackbar style="z-index: 9999" class="pt-6 pr-md-6 snakbar-sty rounded-pill" elevation="0" text-color="white"
        transition="slide-x-reverse-transition" v-model="errorSnackbar" :timeout="4000" :value="true" color="error">
        <v-icon class="mr-2" color="white">mdi-alert-outline</v-icon>
        {{ errtext }}
        <v-icon @click="errorSnackbar = false" class="float-right" color="white">mdi-close-circle</v-icon>
      </v-snackbar>
      <v-snackbar class="pt-6 pr-md-6 snakbar-sty rounded-pill" elevation="0" text-color="white"
        transition="slide-x-reverse-transition" v-model="successSnackbar" :timeout="4000" :value="true" color="#43A833">
        <v-icon class="mr-2" color="white">mdi-alert-outline</v-icon>
        {{ Succtext }}
        <v-icon @click="successSnackbar = false" class="float-right" color="white">mdi-close-circle</v-icon>
      </v-snackbar>
      <v-overlay :value="blurLoader" class="rounded-0" style="z-index: 2000">
        <div class="text-center">
          <v-progress-circular :size="60" :width="4" color="#0037B7" indeterminate></v-progress-circular>
        </div>
      </v-overlay>
      <v-dialog v-model="confirmation" persistent min-width="380" :fullscreen="$vuetify.breakpoint.smAndDown"
        :max-width="addNewSeg ? '500' : '420'">
        <v-card class="px-2 px-md-2" :class="$vuetify.breakpoint.smAndDown ? 'rounded-md' : 'rounded-lg'">
          <v-card-title class="pr-2"
            :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-title font-weight-bold' : ''">Cancel request?
            <v-spacer></v-spacer>
            <v-btn icon @click="confirmation = false" v-if="src !== 'mobileapp'">
              <v-icon>mdi-close</v-icon>
            </v-btn></v-card-title>
          <v-card-text :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">
            Are you sure you want to cancel your
            <b>"{{ this.editType }}"</b> request?
          </v-card-text>
          <v-card-actions class="pb-4">
            <!-- <v-btn
                height="40px"
                block
                color="red darken-1 text-none"
                text
                @click="deleteBankapi"
              >
                Delete
              </v-btn> -->
            <v-btn elevation="0" color="black white--text" rounded block @click="rejectEsign" class="d-none d-md-block">
              <span class="text-none">Proceed</span>
            </v-btn>
            <v-footer fixed color="white" v-if="$vuetify.breakpoint.smAndDown">
              <v-btn elevation="0" color="black white--text" rounded block @click="rejectEsign"
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 d-flex mb-3' : ''">
                <span class="text-none">Proceed</span>
              </v-btn>
            </v-footer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editdialog"
        :transition="$vuetify.breakpoint.xsOnly ? 'dialog-bottom-transition' : 'scale-transition'" persistent
        :fullscreen="$vuetify.breakpoint.smAndDown" :max-width="addNewSeg ? '500' : '420'" min-width="390">
        <v-card class="pb-4 px-md-4" :class="$vuetify.breakpoint.smAndDown ? 'rounded-md' : 'rounded-lg'">
          <v-snackbar style="z-index: 9999" class="pt-6 pr-md-6 snakbar-sty rounded-pill" elevation="0"
            text-color="white" transition="slide-x-reverse-transition" v-model="errorSnackbar" :timeout="4000"
            :value="true" color="error">
            <v-icon class="mr-2" color="white">mdi-alert-outline</v-icon>
            {{ errtext }}
            <v-icon @click="errorSnackbar = false" class="float-right" color="white">mdi-close-circle</v-icon>
          </v-snackbar>
          <div v-if="requestotp">
            <v-form ref="form">
              <v-card-title style="font-size: 16px"
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-title font-weight-bold' : ''">
                Mobile change request <v-spacer></v-spacer>
                <v-btn icon @click="closeBtn" v-if="src !== 'mobileapp'">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <!-- <p class="ma-0 pa-0" style="font-weight:499">Old Mobile number</p> -->
                <p class="ma-0 pa-0 font-weight-medium txt-666"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Present Number</p>
                <v-text-field dense class="pa-0" readonly type="number" hide-spin-buttons
                  v-model="profileData.MOBILE_NO" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''">
                  <!-- <template #prepend-inner>
                <div style="width:30px">
                  <v-img class="mt-1" max-height="16" max-width="16" src="@/assets/mobile-phone.svg"/>
                </div>
              </template> -->
                </v-text-field>
                <p class="ma-0 pa-0" style="font-weight: 499"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">New Mobile number <span
                    style="color: red">*</span></p>
                <v-text-field class="pa-0" required type="number" hide-spin-buttons @keyup="checkSame"
                  :rules="mobileNumberRules" placeholder="Enter Mobile no" v-model="usernewmobile"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''">
                  <template #prepend-inner>
                    <div style="width: 30px">
                      <v-img class="mt-1" max-height="16" max-width="16" src="@/assets/mobile-phone.svg" />
                    </div>
                  </template>
                </v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn elevation="0"
            color="black white--text px-8 "
            rounded
              @click="editdialog = false"
            >
              Close
            </v-btn> -->
                <v-btn height="40px" elevation="0" color="black white--text " rounded block :loading="mobileLoader"
                  @click="sendButtonClicked" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''"
                  class="d-none d-md-block">
                  <span class="text-none px-8">Submit</span>
                </v-btn>
                <v-footer fixed color="white" v-if="$vuetify.breakpoint.smAndDown">
                  <v-btn height="40px" elevation="0" color="black white--text " rounded block :loading="mobileLoader"
                    @click="sendButtonClicked"
                    :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 d-flex mb-3' : ''">
                    <span class="text-none px-8">Submit</span>
                  </v-btn>
                </v-footer>
              </v-card-actions>
            </v-form>
          </div>
          <div v-if="kraImgCapture">
            <v-form ref="form">
              <v-card-title style="font-size: 16px"
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-title font-weight-bold' : ''">
                Let's take a selfie<v-spacer></v-spacer>
                <v-btn icon @click="closeBtn" v-if="src !== 'mobileapp'">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <!-- <p class="ma-0 pa-0" style="font-weight:499">Old Mobile number</p> -->
                <p class="ma-0 pa-0 font-weight-medium txt-666"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-subtitle' : ''">Click a selfie for your Re-KYC
                  verification. Please make
                  sure
                  you are in a well-lit area.</p>
                <div></div>
                <div id="app" class="web-camera-container">
                  <div align="center" class="camera-button mt-4">
                    <v-btn :ripple="false" v-if="!isCameraOpen && !isPhotoTaken" height="40px" elevation="0" outlined style="border: 1px solid #000 !important" rounded block class="text-none" @click="toggleCamera">
                      <span :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Open Camera</span>
                    </v-btn>
                    <div v-if="!isCameraOpen && !isPhotoTaken" class="my-2">
                      <span class="font-weight-medium txt-666" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">OR</span>
                    </div>
                    <v-btn :ripple="false" v-if="!isCameraOpen && !isPhotoTaken" height="40px" elevation="0" outlined style="border: 1px solid #000 !important" rounded block class="text-none" @click="$refs.photoUploadMobile.click()">
                      <v-icon left small>mdi-upload</v-icon>
                      <span :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Upload Photo</span>
                    </v-btn>
                    <input type="file" ref="photoUploadMobile" accept="image/*" style="display:none" @change="onPhotoUpload" />
                  </div>

                  <div v-show="isCameraOpen && isLoading" class="camera-loading"></div>

                  <div v-if="isCameraOpen || isPhotoTaken" v-show="!isLoading" class="camera-box" :class="{ flash: isShotPhoto }">
                    <div class="camera-shutter" :class="{ flash: isShotPhoto }"></div>

                    <video v-show="!isPhotoTaken && isCameraOpen" ref="camera" width="100%" height="100%" autoplay></video>

                    <div v-show="isPhotoTaken" class="crop-container">
                      <canvas id="photoTakenMobile" ref="canvas" :width="475" :height="520" class="crop-canvas"></canvas>
                      <div v-if="isUploadedPhoto" class="crop-box"
                        :style="{
                          left: (cropX / 475 * 100) + '%',
                          top: (cropY / 520 * 100) + '%',
                          width: (cropW / 475 * 100) + '%',
                          height: (cropH / 520 * 100) + '%'
                        }"
                        @mousedown.prevent="startCropDrag"
                        @touchstart.prevent="startCropDrag">
                      </div>
                    </div>
                  </div>

                  <div align="center" v-if="isCameraOpen && !isLoading" class="camera-shoot">
                    <v-btn :ripple="false" height="40px" elevation="0" outlined style="border: 1px solid #000 !important" rounded block class="text-none mt-3" @click="takePhoto">
                      <div v-if="isPhotoTaken && isCameraOpen"
                        :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Retry</div>
                      <div v-else :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Capture</div>
                    </v-btn>
                  </div>
                  <div align="center" v-if="isPhotoTaken && !isCameraOpen" class="camera-shoot">
                    <v-btn :ripple="false" height="40px" elevation="0" outlined style="border: 1px solid #000 !important" rounded block class="text-none mt-3" @click="resetUpload">
                      <div :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Change Photo</div>
                    </v-btn>
                  </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn height="40px" elevation="0" color="black white--text d-none d-md-block" rounded block
                  :loading="mobileLoader" @click="checkKraandsentOTP">
                  <span class="text-none px-8">Submit</span>
                </v-btn>
                <v-btn v-if="$vuetify.breakpoint.smAndDown" height="40px" elevation="0" color="black white--text ml-n2"
                  rounded block :loading="mobileLoader" @click="checkKraandsentOTP">
                  <span class="text-none px-8"
                    :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Submit</span>
                </v-btn>
              </v-card-actions>
            </v-form>
          </div>
          <div v-if="verifyotp">
            <v-form ref="formm">
              <v-card-title style="font-size: 16px"
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-title font-weight-bold' : ''">
                Verify Your new number
                <v-spacer></v-spacer>
                <v-btn icon @click="closeBtn" v-if="src !== 'mobileapp'">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <p class="ma-0 pa-0" style="font-weight: 499"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Mobile number <span
                    style="color: red">*</span></p>
                <v-text-field class="pa-0" readonly hide-spin-buttons v-model="usernewmobile"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''">
                  <template #prepend-inner>
                    <div style="width: 30px">
                      <v-img class="mt-1" max-height="16" max-width="16" src="@/assets/mobile-phone.svg" />
                    </div>
                  </template>
                </v-text-field>
                <p class="ma-0 pa-0" style="font-weight: 499"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Enter 4 digit OTP sent to mobile
                  no.<span style="color: red">*</span></p>
                <v-text-field class="pa-0" required type="number" hide-spin-buttons pattern="\d*" maxlength="4"
                  :rules="otpRules" placeholder="00-00" v-model="userOtp"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''">
                  <template #prepend-inner>
                    <div style="width: 30px">
                      <v-img class="mt-1" max-height="16" max-width="16" src="@/assets/mobile-chat.svg" />
                    </div>
                  </template>
                </v-text-field>
                <!-- <p class="ma-0 pa-0">OTP</p>
                                <v-otp-input
                length="4" plain style="height:40px"
              ></v-otp-input> -->
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn elevation="0"
            color="black white--text px-8 "
            rounded
              @click="editdialog = false"
            >
              Close
            </v-btn> -->
                <v-btn height="40px" elevation="0" color="black white--text" class="d-none d-md-block" rounded block
                  :loading="mobileLoader" @click="otpButtonClicked">
                  <span class="text-none px-8">Submit</span>
                </v-btn>
                <v-footer fixed color="white" v-if="$vuetify.breakpoint.smAndDown">
                  <v-btn height="40px" elevation="0" color="black white--text" rounded block :loading="mobileLoader"
                    @click="otpButtonClicked"
                    :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 d-flex mb-3' : ''">
                    <span class="text-none px-8">Submit</span>
                  </v-btn>
                </v-footer>
              </v-card-actions>
            </v-form>
          </div>
          <div v-if="requestotpemail">
            <v-form ref="formemailreq">
              <v-card-title style="font-size: 16px"
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-title font-weight-bold' : ''">
                Email change request <v-spacer></v-spacer>
                <v-btn icon @click="closeBtn" v-if="src !== 'mobileapp'">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <p class="ma-0 pa-0 font-weight-medium txt-666"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Old email id</p>

                <v-text-field class="pa-0" readonly v-model="profileData.CLIENT_ID_MAIL"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''"></v-text-field>
                <p class="ma-0 pa-0" style="font-weight: 499"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">New email id <span
                    style="color: red">*</span></p>

                <v-text-field class="pa-0" required @keyup="usercopytest" :rules="emailRules"
                  placeholder="Enter New email" v-model="usernewemail"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''">
                  <template #prepend-inner>
                    <div style="width: 30px">
                      <v-img class="mt-1" max-height="16" max-width="16" src="@/assets/mail-box.svg" />
                    </div>
                  </template>
                </v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn elevation="0"
            color="black white--text px-8 "
            rounded
              @click="editdialog = false"
            >
              Close
            </v-btn> -->
                <v-footer fixed color="white" v-if="$vuetify.breakpoint.smAndDown">
                  <v-btn height="40px" elevation="0" color="black white--text " rounded block :loading="emailLoader"
                    @click="sendButtonClicked"
                    :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 d-flex mb-3' : ''">
                    <span class="text-none px-8">Submit</span>
                  </v-btn>
                </v-footer>
                <v-btn height="40px" elevation="0" class="d-none d-md-block" color="black white--text " rounded block
                  :loading="emailLoader" @click="sendButtonClicked"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">
                  <span class="text-none px-8">Submit</span>
                </v-btn>
              </v-card-actions>
            </v-form>
          </div>
          <div v-if="verifyotpemail">
            <v-form ref="formemailveri">
              <v-card-title style="font-size: 16px"
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-title font-weight-bold' : ''">
                Verify Your new email
                <v-spacer></v-spacer>
                <v-btn icon @click="closeBtn" v-if="src !== 'mobileapp'">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <p class="ma-0 pa-0" style="font-weight: 499"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">New email id</p>
                <v-text-field class="pa-0" readonly v-model="usernewemail"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''">
                  <template #prepend-inner>
                    <div style="width: 30px">
                      <v-img class="mt-1" max-height="16" max-width="16" src="@/assets/mail-box.svg" />
                    </div>
                  </template>
                </v-text-field>

                <p class="ma-0 pa-0" style="font-weight: 499"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">
                  Enter 4 digit OTP sent to your e-mail.
                  <span style="color: red">*</span>
                </p>
                <v-text-field class="pa-0" required type="number" hide-spin-buttons pattern="\d*" maxlength="4"
                  :rules="otpRules" placeholder="00-00" v-model="useremailOtp"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''">
                  <template #prepend-inner>
                    <div style="width: 30px">
                      <v-img class="mt-1" max-height="16" max-width="16" src="@/assets/mobile-chat.svg" />
                    </div>
                  </template>
                </v-text-field>
                <!-- <p class="ma-0 pa-0">OTP</p>
                                <v-otp-input
    length="4" plain style="height:40px"
  ></v-otp-input> -->
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn elevation="0"
            color="black white--text px-8 "
            rounded
              @click="editdialog = false"
            >
              Close
            </v-btn> -->
                <v-btn height="40px" elevation="0" color="black white--text " rounded block :loading="emailLoader"
                  @click="otpButtonClicked" class="d-none d-md-block">
                  <span class="text-none px-8">Submit</span>
                </v-btn>
                <v-footer fixed color="white" v-if="$vuetify.breakpoint.smAndDown">
                  <v-btn height="40px" elevation="0" color="black white--text " rounded block :loading="emailLoader"
                    :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 d-flex mb-3' : ''"
                    @click="otpButtonClicked">
                    <span class="text-none px-8">Submit</span>
                  </v-btn>
                </v-footer>
              </v-card-actions>
            </v-form>
          </div>
          <div v-if="adresschange">
            <v-card-title style="font-size: 16px"
              :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-title font-weight-bold' : ''">
              Address change request <v-spacer></v-spacer>
              <v-btn icon @click="closeBtn" v-if="src !== 'mobileapp'">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <div class="mx-4 mb-4" v-if="adressOptions">
              <v-btn height="40px" color="#000" elevation="0" class="white--text text-none" block rounded
                @click="kraImageCheck" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 mt-4 mb-6' : ''">
                Aadhar
                (Digilocker) </v-btn>
            </div>

            <!-- <div class="mx-4 mb-2" v-if="adressOptions">
              <v-btn height="40px" elevation="0" outlined style="border: 1px solid #000 !important" rounded
                class="text-none" block @click="(adressOptions = false), (manual = true)"
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''"> Type manually </v-btn>
            </div> -->

            <v-form v-if="manual" ref="formadress" :class="$vuetify.breakpoint.smAndDown ? 'pb-6' : ''">
              <v-card-text>
                <p class="ma-0 pa-0 font-weight-medium txt-666"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Old Address</p>

                <v-text-field readonly class="pa-0" v-model="profileData.CL_RESI_ADD1"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''"></v-text-field>
                <p class="ma-0 pa-0 font-weight-bold"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">
                  New
                  Address <span style="color: red">*</span></p>

                <v-text-field class="pa-0" required :rules="addressRules" placeholder="New Address"
                  v-model="usernewAdress"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version pb-3' : ''"></v-text-field>

                <!-- PINCODE FOR MANUAL ADDRESS -->
                <v-row no-gutters>
                  <v-col>
                    <v-list-item class="pa-0 pr-2">
                      <v-list-item-content class="pa-0">
                        <p class="ma-0 pa-0 font-weight-bold"
                          :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 p' : ''">Pincode <span
                            style="color: red">*</span></p>
                        <v-text-field class="pa-0" hide-spin-buttons type="number" placeholder="PINCODE"
                          :loading="pinLoader" v-model="pincodeAddress" @keyup="pincodeFetch()" :rules="nomineeField"
                          :class="$vuetify.breakpoint.smAndDown ? 'mobile-version pb-3' : ''"></v-text-field>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item class="pa-0 pr-2">
                      <v-list-item-content class="pa-0">
                        <p class="ma-0 pa-0 font-weight-bold"
                          :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">State <span
                            style="color: red">*</span></p>

                        <v-text-field class="pa-0" :rules="nomineeField" placeholder="STATE" v-model="stateAddress"
                          :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''"></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col>
                    <v-list-item class="pa-0 pl-2">
                      <v-list-item-content class="pa-0">
                        <p class="ma-0 pa-0 font-weight-bold"
                          :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">District <span
                            style="color: red">*</span></p>

                        <v-text-field class="pa-0" :rules="nomineeField" placeholder="DISTRICT" v-model="distAddress"
                          :class="$vuetify.breakpoint.smAndDown ? 'mobile-version pb-3' : ''"></v-text-field>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item class="pa-0 pl-2">
                      <v-list-item-content class="pa-0">
                        <p class="ma-0 pa-0 font-weight-bold"
                          :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">Country <span
                            style="color: red">*</span></p>

                        <v-text-field class="pa-0" :rules="nomineeField" placeholder="COUNTRY" v-model="countryAddress"
                          :class="$vuetify.breakpoint.smAndDown ? 'mobile-version' : ''"></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>

                <p class="ma-0 pa-0 font-weight-bold"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 pt-3' : ''">Proof type <span
                    style="color: red">*</span></p>

                <v-select class="pa-0" :items="prooftype" :rules="nomineeField" v-model="proofTypes"
                  placeholder="Proof type"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version pb-3' : ''"></v-select>

                <p class="ma-0 pa-0 font-weight-bold pb-2"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 pb-2' : ''">Upload proof <span
                    style="color: red">*</span></p>
                <v-card color="rgba(246, 247, 247, 0.5)" @ondragover="onChange"
                  :class="dragging ? 'dropAreaDragging' : ''" @dragenter="dragging = true" @dragend="dragging = false"
                  @dragleave="dragging = false" class="fileupload elevation-0 rounded-lg text-center pa-2  mb-4"
                  style="border: 1px dashed #d0d3d6">
                  <!-- <v-card class="pa-3" @click="openFileInput()"> -->
                  <!-- <div align="center"> -->
                  <!-- <p style="font-weight:499;font-size:15px;color:#0037B7"  class="ma-0"> Click here to upload</p> -->
                  <!-- <p>You can drop your last 6 months Bank statement here to be uploaded</p> -->
                  <div class="innerfilup">
                    <!-- <img class="mb-2" src="@/assets/file drop.svg" width="48px" /> -->
                    <p class="font-weight-bold fs-18" style="color: #0037b7 !important ; margin-bottom: 0em">Upload your
                      Address Proof</p>
                    <p class="mb-1 txt-666 font-weight-regular" style="line-height: 18px">Select a file or drag it into
                      the
                      box below.
                    </p>
                  </div>
                  <label for="fileUpload" class="custom-upload-btn"><v-icon small class="mr-1"
                      color="white">mdi-upload</v-icon>Choose File</label>
                  <input type="file" id="fileUpload" accept=".pdf" name="items[]" required multiple @change="onChange"
                    style="display: none" />

                  <!-- <div v-if="panFile" class="mt-4 ml-2">
                  <v-icon color="green" class="mr-1" small>mdi-check</v-icon>
                  <span class="grey--text caption">{{ panimagedata.name }}</span>
                </div>
                <div v-else class="mb-4 ml-4 grey--text caption">No file chosen</div> -->
                  <div class=" grey--text text--darken-2 ml-1 mt-3 font-weight-regular"
                    style="font-size:13px!important;">
                    Accepted formats: .pdf</div>
                  <!-- </div> -->
                </v-card>
                <div v-if="panFile" class="mt-4 ml-2 pb-4">
                  <v-icon color="green" class="mr-1 pb-1" small>mdi-check</v-icon>
                  <span class="grey--text text--darken-3" style="font-size:14px!important;">{{ panimagedata.name
                  }}</span>
                </div>
                <!-- <div v-if="panFile">
                <p>
                  <span class="txt-666">File names</span> :
                  <b>{{ panimagedata.name }}</b>
                </p>
              </div> -->
                <!-- <div class="text-right mb-2"> -->
                <!-- <v-card width="100%" class="elevation-0 mb-16 mb-md-0" style="transform: scaleX(-1) !important">
                                <iframe style="border: none; border-radius: 8px;" :src="panimage" width="100%"
                                    height="240"></iframe>
                            </v-card> -->

                <!-- </div> -->
                <!-- <v-file-input
                prepend-icon=""
                prepend-inner-icon="mdi-paperclip"
                class="pa-0"
                :rules="nomineeField"
                v-model="adressproffdoc"
                accept="image/*,.pdf"
                placeholder="Upload Proof"
              ></v-file-input> -->
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn elevation="0"
            color="black white--text px-8 "
            rounded
              @click="editdialog = false"
            >
              Close
            </v-btn> -->
                <v-btn height="40px" elevation="0" color="black white--text" rounded :loading="addressLoader" block
                  @click="kraImageCheck" class="d-none d-md-block"
                  :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">
                  <span class="text-none px-8">Submit</span>
                </v-btn>
                <v-footer fixed color="white" v-if="$vuetify.breakpoint.smAndDown">
                  <v-btn height="40px" elevation="0" color="black white--text " rounded :loading="addressLoader" block
                    @click="kraImageCheck"
                    :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 d-flex mb-3' : ''">
                    <span class="text-none px-8">Submit</span>
                  </v-btn>
                </v-footer>
              </v-card-actions>
            </v-form>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="esignconfirmation" persistent min-width="380" :fullscreen="$vuetify.breakpoint.smAndDown"
        :max-width="addNewSeg ? '500' : '420'">
        <v-card class="px-2 px-md-2" :class="$vuetify.breakpoint.smAndDown ? 'mb-2 pb-4 rounded-md' : 'rounded-lg'">
          <v-card-title class="pr-2"
            :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-title font-weight-bold' : ''">E-Sign Is Pending !
            <v-spacer></v-spacer>
            <v-btn icon @click="esignconfirmation = false, diaesigntype = ''" v-if="src !== 'mobileapp'">
              <v-icon>mdi-close</v-icon>
            </v-btn></v-card-title>
          <v-card-text class="font-weight-bold" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">
            Your {{ diaesigntype == "mobile" ? "Mobile" : diaesigntype == "email" ? "Email" : diaesigntype == "address"
              ?
              "Address" : "" }} Change request is not yet Completed,

          </v-card-text>
          <v-card-actions class="pb-4">
            <!-- <v-btn
                height="40px"
                block
                color="red darken-1 text-none"
                text
                @click="deleteBankapi"
              >
                Delete
              </v-btn> -->
            <v-btn v-if="diaesigntype == 'mobile'" elevation="0" color="black white--text" rounded block
              class="d-none d-md-block"
              @click="digioEsign(mobStatus.mobile_file_id, mobStatus.mob_client_email.toUpperCase(), mobStatus.mob_session), (editType = 'mobile_change'), diaesigntype = ''">
              <span class="text-none"> Click here E-sign</span>
            </v-btn>
            <v-footer fixed color="white" v-if="$vuetify.breakpoint.smAndDown">
              <v-btn v-if="diaesigntype == 'mobile'" elevation="0" color="black white--text" rounded block
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 d-flex mb-3' : ''"
                @click="digioEsign(mobStatus.mobile_file_id, mobStatus.mob_client_email.toUpperCase(), mobStatus.mob_session), (editType = 'mobile_change'), diaesigntype = ''">
                <span class="text-none"> Click here E-sign</span>
              </v-btn>
            </v-footer>
            <v-btn v-if="diaesigntype == 'email'" elevation="0" color="black white--text" rounded block
              class="d-none d-md-block"
              @click="digioEsign(mobStatus.email_file_id, mobStatus.email_new_email_id.toLowerCase(), mobStatus.email_session), (editType = 'email_change'), diaesigntype = ''">
              <span class="text-none"> Click here E-sign</span>
            </v-btn>
            <v-footer fixed color="white" v-if="$vuetify.breakpoint.smAndDown">
              <v-btn v-if="diaesigntype == 'email'" elevation="0" color="black white--text" rounded block
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 d-inline-flex mb-3' : ''"
                @click="digioEsign(mobStatus.email_file_id, mobStatus.email_new_email_id.toLowerCase(), mobStatus.email_session), (editType = 'email_change'), diaesigntype = ''">
                <span class="text-none"> Click here E-sign</span>
              </v-btn>
            </v-footer>

            <v-btn v-if="diaesigntype == 'address'" elevation="0" color="black white--text" rounded block
              class="d-none d-md-block"
              @click="(editType = 'address_change'), digioEsign(mobStatus.address_file_id, mobStatus.address_client_email.toLowerCase(), mobStatus.address_session), diaesigntype = ''">
              <span class="text-none"> Click here E-sign</span>
            </v-btn>
            <v-footer fixed color="white" v-if="$vuetify.breakpoint.smAndDown" class="mb-1">
              <v-btn v-if="diaesigntype == 'address'" elevation="0" color="black white--text" rounded block
                :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1 d-flex mb-3' : ''"
                @click="(editType = 'address_change'), digioEsign(mobStatus.address_file_id, mobStatus.address_client_email.toLowerCase(), mobStatus.address_session), diaesigntype = ''">
                <span class="text-none"> Click here E-sign</span>
              </v-btn>
            </v-footer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-app>
</template>

<style lang="scss" scoped>
.v-btn:not(.v-btn--round).v-size--small {
  height: 0px;
  min-width: 0px;
  /* padding: 0 12.4444444444px; */
  padding-left: 12px;
  padding-right: 12px;

  padding-top: 10px;
  padding-bottom: 10px;
}
</style>

<style scoped>
.mobile-version ::v-deep .v-label {
  font-size: 22px !important;
}

.mobile-version ::v-deep input {
  font-size: 16px !important;
}

.mobile-version ::v-deep .v-input__control {
  font-size: 16px !important;
}

.mobile-version ::v-deep input::placeholder {
  font-size: 16px !important;
}

/* .mobile-version ::v-deep .v-select-list{
  font-size: 24px !important;
} */

.mobile-version-title ::v-deep {
  font-size: 22px !important;
}

.mobile-version-subtitle ::v-deep {
  font-size: 15px !important;
}

.mobile-version-sub ::v-deep {
  font-size: 14px !important;
}

.mobile-version-sub1 ::v-deep {
  font-size: 18px !important;
}

.sub-align {
  line-height: 18px !important;
  letter-spacing: 0.015rem !important;
}

.title-align {
  letter-spacing: 0.010rem !important;
}

.custom-upload-btn {
  display: inline-block;
  margin-top: 10px;
  padding: 8px 16px;
  background-color: #0037b7;
  color: white;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer !important;
}

.scroll-address::-webkit-scrollbar {
  display: none;
}

.crop-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.crop-canvas {
  display: block;
  width: 100%;
}

.crop-box {
  position: absolute;
  border: 2px solid #00e676;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
  cursor: move;
  z-index: 10;
  touch-action: none;
}
</style>

<!-- <style>
.scroll-container,
  .scroll-container:hover,
  .scroll-container:focus { 
            
            overflow-y: scroll; 
        } 
        
  
        .scroll-container::-webkit-scrollbar { 
            width: 5px; 
        } 
  
        .scroll-container::-webkit-scrollbar-track { 
            background: #f1f1f1; 
        } 
  
        .scroll-container::-webkit-scrollbar-thumb { 
          background: #e5ebec; 
            border-radius: 10px;
        } 
  
        .scroll-container::-webkit-scrollbar-thumb:hover { 
            background: #555; 
        } 
  
        .scroll-container::-webkit-scrollbar-button { 
            display: none; 
        } 
</style> -->
<script src="https://app.digio.in/sdk/v11/digio.js"></script>

<script>
const script = document.createElement("script");
script.src = "https://app.digio.in/sdk/v11/digio.js";
document.body.appendChild(script);
import api from "@/Api.js";
// import * as faceapi from 'face-api.js';
import axios from "axios";
export default {
  // name: "BarChart",

  components: {},
  data() {
    return {
      diaesigntype:"",
      esignconfirmation:false,
      xsOnly: null,
      smAndDowm: null,
      txt: "",
      accountNum: "",
      upiDisabled: false,
      verifyBtn: true,
      upiLoader: false,
      errtext: "",
      errorSnackbar: false,
      snackbar: false,
      checkClientVPA: [],
      verfy: true,
      // items: [],
      isHidden: true,
      client_code: null,
      name: null,
      email: null,
      mobile: null,
      acc_no: null,
      ifsc: null,
      loading: false,
      selection: 0,
      url_data: null,
      oid: null,
      amount: null,
      valid: true,
      vpa: null,
      attrs: null,
      company: null,
      company_code: [],
      amountRules: [(v) => !!v || "Enter Amount", (v) => (v && v >= 10) || "Should be above 10"],
      upiRules: [(v) => !!v || "Enter UPI ID", (v) => /.+@.+/.test(v) || "Invalid UPI ID"],
      submit_this_val: null,
      bankDetails: [],
      // snackbar: false,
      clietData: "",
      togg: false,
      selectionAtom: 0,
      profileData: [],
      colatral: "",
      message: "Hai da Goopal",
      secretKey: "asdfghjklzxcvbnm",
      dataToEncrypt: "Sensitive information you want to encrypt.",
      token: "",
      publicIP: "",
      statusChk: [],
      Succtext: "",
      successSnackbar: false,
      profileLoader: true,
      BankData: [],
      submitBtndisable: true,
      equty: [],
      commoditi: [],
      derivat: [],
      editdialog: false,

      //asdkjbnasdl
      chha: false,
      nifity: true,
      widthdat: [50, 50, 50, 50, 80],
      chip1: true,
      chip2: true,
      chip3: true,
      chip4: true,
      linkUrl: "#",
      zebu: "https://zebuetrade.com/",
      toggleMenu: true,
      drawer: false,
      selectedItem: 0,
      tab: 0,
      mobileNumber: "",
      cardTitle: "",
      dependency: ["Self", "Spouse", "child Dependent", "parents Dependent"],
      dependencyValue: "Self",
      number: true,
      otpvalid: "",
      otpValue: "",
      dependentName: "",
      headerProps: {
        class: "custom-header",
      },
      subTitle: "",
      mobileVerification: false,
      emailVerification: false,
      emailid: "",
      emailvalid: true,
      cardLoader: false,
      addressVerification: false,
      newNomineepercent: "",
      newNomineeAddress: "",
      newNomineeDob: "",
      newNomineeRelation: "",
      newNomineeName: "",
      nomineePop: false,
      personalDetail: false,
      activePicker: null,
      date: null,
      datee: null,
      datento: null,
      dateento: null,
      datenthre: null,
      dateenthre: null,

      menuu: false,
      menunto: false,
      menuunto: false,

      menunthre: false,
      menuunthre: false,
      menu: false,
      newNomineeProof: "",
      relationNominee: ["Mother", "Father", "Brother", "Sister", "Daughter", "Wife", "Husband", "Son", "Grand-Son", "Grand-Father", "Grand-Daughter", "Grand-Mother"],
      newNomineeCity: "",
      newNomineePincode: "",
      newNomineeState: "",
      newNomineeCountry: "",
      pinLoader: false,
      nomineeForm: false,
      yesorno: "no",
      nomineeYes: false,
      nomineeMobile: "",
      nomineeEmail: "",
      checkbox: true,
      newNomineePan: "",

      nomineeMobilento: "",
      nomineeEmailnto: "",
      checkboxnto: true,
      newNomineePannto: "",

      nomineeMobilenthre: "",
      nomineeEmailnthre: "",
      checkboxnthre: true,
      newNomineePannthre: "",
      newNomineeNamenthre: "",
      newNomineeRelationnthre: "",

      optionOfupdate: "",
      radioBtn: false,
      nomineesubmitBtn: false,
      submissionText: "",
      filedegio: "",
      esignBtn: false,
      newNomineeGuardian: "",
      newNomineeGuardiannto: "",
      newNomineeGuardiannthre: "",

      belowAge: false,
      belowAgento: false,
      belowAgenthre: false,

      newNomineeGuardianRelation: "",
      newNomineeGuardianRelationnto: "",
      newNomineeGuardianRelationnthre: "",
      newNomineegurdianmobile: "",
      newNomineegurdianmobilento: "",
      newNomineegurdianmobilenthre: "",

      checkboxTow: false,
      checkboxThree: false,

      newNomineeNameto: "",
      newNomineeRelationto: "",

      newNomineepercentone: 100,
      newNomineepercentnto: 1,
      newNomineepercentnthre: 1,
      max: 100,
      secnompercentmax: 0,
      thernompercentmax: 0,
      hashpan: "",

      newNomineeGuardianEmail: "",
      newNomineeGuardianAddress: "",
      newNomineeGuardianPincode: "",
      newNomineeGuardianState: "",
      newNomineeGuardianCity: "",
      newNomineeGuardianCountry: "",

      newNomineeGuardianEmailnto: "",
      newNomineeGuardianAddressnto: "",
      newNomineeGuardianPincodento: "",
      newNomineeGuardianStatento: "",
      newNomineeGuardianCitynto: "",
      newNomineeGuardianCountrynto: "",

      newNomineeGuardianEmailnthre: "",
      newNomineeGuardianAddressnthre: "",
      newNomineeGuardianPincodenthre: "",
      newNomineeGuardianStatenthre: "",
      newNomineeGuardianCitynthre: "",
      newNomineeGuardianCountrynthre: "",

      nominee2: false,
      newNomineeName2: "",
      newNomineeRelation2: "",
      newNomineeDob2: "",
      newNomineepercent2: "",

      nominee3: false,
      newNomineeName3: "",
      newNomineeRelation3: "",
      newNomineeDob3: "",
      newNomineepercent3: "",

      usernewmobile: "",
      newmobilerules: [(v) => !v || v.length <= 10 || "Enter a valid mobile number", (v) => !!v || "Mobile is required"],
      requestotp: true,
      verifyotp: false,
      userOtp: "",
      editType: "",
      mobStatus: [],
      mobileDisable: false,
      usernewemail: "",
      requestotpemail: false,
      useremailOtp: "",
      verifyotpemail: false,
      usernewAdress: "",
      adresschange: false,
      proofTypes: "",
      prooftype: ["Aadhar card", "Passport", "VoterID", "Driving licence"],
      emailDisable: false,
      emailRules: [(v) => !/^\s/.test(v) || "E-mail cannot start with spaces", (v) => !!v || "E-mail is required", (v) => /.+@.+/.test(v) || "E-mail must be valid", (v) => !/\s/.test(v) || "Email cannot contain spaces"],
      addressRules: [(v) => !!v || "Address is required", (v) => !/^\s/.test(v) || "Address cannot start with spaces"],

      adressproffdoc: null,
      manual: false,
      addressDisable: false,
      autoOpenAddress: false,
      digilockerReturn: false,
      blurLoader: false,
      emailLoader: false,
      addressLoader: false,
      mobileLoader: false,
      userEmailadress: "",
      stateAddress: "",
      countryAddress: "",
      distAddress: "",
      pincodeAddress: "",

      // BANK INIT
      bankproffdoc: null,
      bankAccountnumber: "",
      bankIfscCode: "",
      bankchange: false,

      ifscBankInfo: [],
      // setDefault:'',
      existingBanks: [],
      defaultCheckbox: false,
      confirmation: false,
      deletebank: [],
      bankLoader: false,
      annualIncomechange: false,
      selectionas: null,
      proofField: false,
      incorrectPass: false,
      passwordField: false,

      imgType: null,
      typeProof: "",
      pdfPassword: "",
      passwordeye: false,
      paswordverification: true,
      annualuserOtp: "",
      annualIncomeverifyotp: false,
      items: ["Below 1L", "1L to 5L", "5L to 10L", "10L to 25L", "Above 25L"],
      itemSelected: "",
      yearlyIncomeDisable: false,
      segments: false,
      nsecash: false,
      bsecash: false,
      mfbse: false,
      bsefno: false,
      nsefno: false,
      cdnse: false,
      cdbse: false,
      // cdbse:false,
      bsecom: false,
      nsecom: false,
      icex: false,
      mcx: false,
      segOpt: false,
      addNewSeg: false,
      activateSeg: false,
      tok: "",

      nsecashDisable: false,
      bsecashDisable: false,
      mfDisable: false,

      bsefnoDisable: false,
      nsefnoDisable: false,
      cdnseDisable: false,
      cdbseDisable: false,

      bsecomDisable: false,
      nsecomDisable: false,
      icexDisable: false,
      mcxDisable: false,

      activateSegBtn: false,
      addsegtype: "",
      newSegements: [],
      segmentbankproffdoc: null,
      inactiveSegments: [],
      existingSegments: [],
      allSegments: ["BSE_CASH", "MF_BSE", "NSE_CASH", "BSE_FNO", "NSE_FNO", "CD_NSE", "CD_BSE", "BSE_COM", "NSE_COM", "ICEX", "MCX"],
      newSegments: [],
      newSegmentSelected: [],
      bankproffdocument: false,
      addsegtypeNew: "",
      mfnse: "",
      nseslbm: "",
      deactivateConfirmation: false,
      aadharstate: "",
      aadharcode: "",
      banklogo: "https://rekycbe.mynt.in/autho",
      reasons: [
        "High brokerage and charges",
        "Monthly maintenance charges",
        "Need better margins",
        "Problem with payment and withdrawal",
        "Need better order placement options",
        "App crashes",
        "Issues with back office portals",
        "Problem with customer service",
        "App is complicated to understand",
        "Faced losses",
        "No time to focus on trading",
      ],
      closureReason: "",
      deactivateForm: true,
      deactivateCanceled: false,
      itemsaaass: [
        {text: "My Account"},
        {
          text: "Profile Details",
          icon: "",
          link: "/accountpage",
          mdiicon: "mdi-chevron-right",
        },
        {
          text: "Bank Accounts Linked",
          icon: "",
          link: "/bankaccount",
          mdiicon: "mdi-chevron-right",
        },
        {
          text: "Set Auto Pay",
          icon: "",
          link: "/autopay",
          mdiicon: "mdi-chevron-right",
        },
        {
          text: "Margin against stocks",
          icon: "",
          link: "/noticationsettings",
          mdiicon: "mdi-chevron-right",
        },
        {text: "Manage Funds", link: "secufund"},
        {
          text: "Securities Funds ",
          icon: "",
          link: "managefund",
          mdiicon: "mdi-chevron-right",
        },
      ],
      actid: "",
      susertoken: "",
      noms: [
        {txt: "Yes, add nominee", val: "yes"},
        {txt: "No, i will do it later", val: "no"},
      ],
      bankprooftype: [
        {txt: "Saving Account", val: "Saving Account"},
        {txt: "Current Account", val: "Current Account"},
      ],
      bankproofTypes: "Saving Account",
      file: null,
      dragging: false,
      panimagedata: [],
      panimage: null,
      panFile: "",
      BankProofselect: "bs",
      customLabel: "Nominee address is same as my address",
      panel: 0,
      cardloader: false,
      dissBtn: true,
      dissBtn2: true,
      dissBtn3: true,
      activetab: "tab1",
      nosegmentsPop: false,
      newFamilyRelation: "",
      memberId: "",
      memberMobile: "",
      memberPan: "",
      validFamily: "",
      familyloader: false,
      familySubmission: false,
      endtxt: "",
      familyRequestData: "",
      familystatusloading: false,
      familyrequest: false,
      selectTableitem: [],
      mobileMember: "",
      disabled: false,
      readonly: false,
      kraImgCapture: false,
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      link: "#",
      imageURL: "",
      capturedImage: null,
      isUploadedPhoto: false,
      // Crop box position in canvas coordinates (475x520)
      cropX: Math.round((475 - 200) / 2),
      cropY: Math.round((520 - 220) / 2),
      cropW: 200,
      cropH: 220,
      isDragging: false,
      dragOffsetX: 0,
      dragOffsetY: 0,
      // Preview mapping: stores how the original image maps to the canvas
      previewSx: 0,
      previewSy: 0,
      previewSw: 0,
      previewSh: 0,
      adressObject: "",
      fileide: "",
      accountstatus: "",
      dialogType: null,
      // typeeeeee:""
      // closenoMobile: false,
      type: null,
      src: null,

      atve_sts:false,
      last7days:false,
      kraimagecapture:'',
      rekyc_status:''
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    menunto(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    menuu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    menuunto(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    menunthre(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    menuunthre(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
  //   '$route.query.type'(newType) {
  //   if (newType === "email") {
  //     this.mobileEdit("email");
  //   } else if (newType === "mobile") {
  //     this.mobileEdit("mobile");
  //   } else if (newType === "address") {
  //     this.mobileEdit("address");
  //   }
  // }
  },
  methods: {
      rkycstatuscheck(){
        this.rekyc_status = ''
      const axios = require('axios');
      let data = JSON.stringify({
        "client_code": this.actid
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://ekycbe.mynt.in/zebu/checkrekyc',
        headers: { 
          'Content-Type': 'application/json'
        },
        data : data
      };
var axiosThis = this
      axios.request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        axiosThis.rekyc_status = response.data.rekyc_status
      })
      .catch((error) => {
        console.log(error);
      });

      },

    rejectEsign() {
      let data = JSON.stringify({
        client_id: this.profileData.CLIENT_ID,
        file_id: this.fileide,
        type: this.editType,
      });

      let config = {
        method: "post",
        url: api.api_url + "/manual_cancel_request",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          this.confirmation = false;
          // console.log(JSON.stringify(response.data));
          if (response.data.msg == "canceled successfully") {
            this.Succtext = "Canceled successfully";
            this.successSnackbar = true;
            this.fetchMobileStatus();
            location.reload();
          } else {
            this.errtext = response.data.msg;
            this.errorSnackbar = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },

    createCameraElement() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.cameraFailed("Camera is not available in this browser. Please upload a photo.");
        return;
      }

      this.isLoading = true;

      const constraints = (window.constraints = {
        audio: false,
        video: true,
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.isLoading = false;
          // Set stream on ALL camera video elements (desktop + mobile)
          this.$nextTick(() => {
            var videos = document.querySelectorAll('.camera-box video');
            for (var i = 0; i < videos.length; i++) {
              videos[i].srcObject = stream;
              videos[i].play().catch((error) => console.log(error));
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          if (error.name == "NotAllowedError") {
            this.cameraFailed("Camera permission is blocked. Please allow it or upload a photo.");
          } else if (error.name == "NotFoundError") {
            this.cameraFailed("No camera found on this device. Please upload a photo.");
          } else if (error.name == "NotReadableError") {
            this.cameraFailed("Camera is being used by another app. Please close it or upload a photo.");
          } else {
            this.cameraFailed("Unable to open the camera. Please upload a photo.");
          }
        });
    },

    cameraFailed(message) {
      this.isCameraOpen = false;
      this.errtext = message;
      this.errorSnackbar = true;
    },

    stopCameraStream() {
      var videos = document.querySelectorAll('.camera-box video');
      for (var i = 0; i < videos.length; i++) {
        if (videos[i].srcObject) {
          videos[i].srcObject.getTracks().forEach(function (track) {
            track.stop();
          });
        }
      }
    },

    // Draw capturedImage preview on all visible canvases
    drawPreviewOnCanvas() {
      var source = this.capturedImage;
      if (!source) return;
      var sW = source.width;
      var sH = source.height;
      var targetRatio = 475 / 520;
      var sourceRatio = sW / sH;
      var sx, sy, sw, sh;
      if (sourceRatio > targetRatio) {
        sh = sH;
        sw = sH * targetRatio;
        sx = (sW - sw) / 2;
        sy = 0;
      } else {
        sw = sW;
        sh = sW / targetRatio;
        sx = 0;
        sy = (sH - sh) / 2;
      }
      // Store mapping for crop calculation
      this.previewSx = sx;
      this.previewSy = sy;
      this.previewSw = sw;
      this.previewSh = sh;
      // Reset crop box to center
      this.cropW = 200;
      this.cropH = 220;
      this.cropX = Math.round((475 - this.cropW) / 2);
      this.cropY = Math.round((520 - this.cropH) / 2);

      var canvases = document.querySelectorAll('.camera-box canvas');
      for (var i = 0; i < canvases.length; i++) {
        var canvas = canvases[i];
        var ctx = canvas.getContext('2d');
        ctx.drawImage(source, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height);
      }
    },

    takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      // Find the active video with a live stream
      var video = null;
      var videos = document.querySelectorAll('.camera-box video');
      for (var i = 0; i < videos.length; i++) {
        if (videos[i].videoWidth > 0) {
          video = videos[i];
          break;
        }
      }
      if (!video) return;

      // Store full resolution capture
      this.isUploadedPhoto = false;
      var fullCanvas = document.createElement('canvas');
      fullCanvas.width = video.videoWidth || 640;
      fullCanvas.height = video.videoHeight || 480;
      fullCanvas.getContext('2d').drawImage(video, 0, 0);
      this.capturedImage = fullCanvas;

      // Draw preview on ALL canvases (desktop + mobile)
      this.drawPreviewOnCanvas();
      this.downloadImage();
    },

    downloadImage() {
      if (this.capturedImage) {
        var tempCanvas = document.createElement('canvas');
        tempCanvas.width = 475;
        tempCanvas.height = 520;
        var ctx = tempCanvas.getContext('2d');
        ctx.drawImage(this.capturedImage, 0, 0, 475, 520);
        this.imageURL = tempCanvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
      }
    },

    onPhotoUpload(event) {
      var file = event.target.files[0];
      if (!file) return;
      var validTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (validTypes.indexOf(file.type) === -1) {
        this.errtext = "Only png, jpg, jpeg image formats are supported.";
        this.errorSnackbar = true;
        return;
      }
      var self = this;
      var reader = new FileReader();
      reader.onload = function (e) {
        var img = new Image();
        img.onload = function () {
          // Store full resolution FIRST (no DOM dependency)
          self.isUploadedPhoto = true;
          var fullCanvas = document.createElement('canvas');
          fullCanvas.width = img.width;
          fullCanvas.height = img.height;
          fullCanvas.getContext('2d').drawImage(img, 0, 0);
          self.capturedImage = fullCanvas;

          // Update state to show canvas
          self.isPhotoTaken = true;
          self.isLoading = false;

          // Wait for Vue to render the canvas in DOM, then draw preview
          self.$nextTick(function () {
            self.drawPreviewOnCanvas();
            self.downloadImage();
          });
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
      // Reset the input so same file can be re-selected
      event.target.value = "";
    },

    resetUpload() {
      this.isPhotoTaken = false;
      this.isUploadedPhoto = false;
      this.capturedImage = null;
      this.imageURL = "";
    },

    startCropDrag(event) {
      this.isDragging = true;
      var clientX = event.touches ? event.touches[0].clientX : event.clientX;
      var clientY = event.touches ? event.touches[0].clientY : event.clientY;
      var container = event.target.closest('.crop-container');
      if (!container) return;
      var rect = container.getBoundingClientRect();
      var mouseCanvasX = (clientX - rect.left) / rect.width * 475;
      var mouseCanvasY = (clientY - rect.top) / rect.height * 520;
      this.dragOffsetX = mouseCanvasX - this.cropX;
      this.dragOffsetY = mouseCanvasY - this.cropY;
      this._dragContainer = container;

      document.addEventListener('mousemove', this.onCropDrag);
      document.addEventListener('mouseup', this.stopCropDrag);
      document.addEventListener('touchmove', this.onCropDrag, { passive: false });
      document.addEventListener('touchend', this.stopCropDrag);
    },

    onCropDrag(event) {
      if (!this.isDragging) return;
      event.preventDefault();
      var clientX = event.touches ? event.touches[0].clientX : event.clientX;
      var clientY = event.touches ? event.touches[0].clientY : event.clientY;
      var container = this._dragContainer;
      if (!container) return;
      var rect = container.getBoundingClientRect();
      var mouseCanvasX = (clientX - rect.left) / rect.width * 475;
      var mouseCanvasY = (clientY - rect.top) / rect.height * 520;
      var newX = mouseCanvasX - this.dragOffsetX;
      var newY = mouseCanvasY - this.dragOffsetY;
      // Clamp within canvas bounds
      this.cropX = Math.max(0, Math.min(475 - this.cropW, Math.round(newX)));
      this.cropY = Math.max(0, Math.min(520 - this.cropH, Math.round(newY)));
    },

    stopCropDrag() {
      this.isDragging = false;
      this._dragContainer = null;
      document.removeEventListener('mousemove', this.onCropDrag);
      document.removeEventListener('mouseup', this.stopCropDrag);
      document.removeEventListener('touchmove', this.onCropDrag);
      document.removeEventListener('touchend', this.stopCropDrag);
    },

    samemembercheck() {
      if (this.memberId == this.client_code) {
        this.memberId = "";
        this.errorSnackbar = true;
        this.errtext = "Not allowed";
      }
    },
    onChange(e) {
      let file = e.target.files[0] || e.dataTransfer.files[0];
      // console.log(file["type"]);
      if (file["type"] == "image/jpeg" || file["type"] == "image/jpg" || file["type"] == "image/png" || file["type"] == "application/pdf") {
        this.panFile = file;
        this.panimage = window.URL.createObjectURL(this.panFile);
        this.panimagedata["name"] = this.panFile.name;
        this.panimagedata["size"] = (this.panFile.size / 1048576).toFixed(1);
        this.passHide();
      } else {
        this.cardloader = false;
        this.toasttext = "Only png, jpg, jpeg image formats are supported.";
        this.snackbar = true;
      }
    },

    openFileInput() {
      // console.log("click input",this.$refs.fileInput.$refs.input.click())
      // Programmatically trigger the click event of the hidden input
      this.$refs.fileInput.$refs.input.click();
    },

    goSso() {
      // if( data)
      // window.location.assign(`http://192.168.5.152:8082/?url=${window.location.href}`)

      window.location.assign(`https://desk.zebuetrade.com/?url=${window.location.href}`);
      // console.log('sso');
    },
    usercopytest() {
      // console.log(this.usernewemail.toUpperCase(),this.profileData.CLIENT_ID_MAIL.toUpperCase())
      if (this.usernewemail.toUpperCase() == this.profileData.CLIENT_ID_MAIL.toUpperCase()) {
        this.usernewemail = "";
        this.errorSnackbar = true;
        this.errtext = "Enter your new email id";
      }
    },

    connectDigio() {
      var stateid = "signup" + Math.random().toString(36).substring(7);
      // FOR LOCAL
      // window.location.href =
      //   "https://api.digitallocker.gov.in/public/oauth2/1/authorize?response_type=code&client_id=692DFD73&state=" +
      //   stateid +
      //   "";

      // -----------------------------------------------------------------------------------------
      // FOR Production
      window.location.href = "https://api.digitallocker.gov.in/public/oauth2/1/authorize?response_type=code&client_id=A987F208&state=" + stateid + "";

      // this.digioEsign(
      //               responceReq.fileid,
      //               responceReq.mailid,
      //               responceReq.session
      //             );
    },
    percentcalc() {
      // console.log('press')
      if (Number(this.newNomineepercentone) > Number(this.max)) {
        this.newNomineepercentone = this.max;
      } else if (Number(this.newNomineepercentone) < 0) {
        this.newNomineepercentone = 0;
      }
    },
    percentcalcnto() {
      // console.log('press')
      // var p1 = this.newNomineepercent
      // var p2 = this.newNomineepercentnto
      // var balance =  Number(p1) - Number(p2)
      // var d = Number(this.max) - this.newNomineepercentnto
      // if (Number(this.max) - this.newNomineepercent){
      var d = Number(this.max) - this.newNomineepercentone;
      this.secnompercentmax = d;
      // this.newNomineepercentnto = d
      // }
      if (Number(this.newNomineepercentnto) > Number(this.secnompercentmax)) {
        this.newNomineepercentnto = this.secnompercentmax;
      } else if (Number(this.newNomineepercentnto) < 0) {
        this.newNomineepercentnto = 0;
      }
    },
    percentcalcnthre() {
      // console.log('press')
      var d = Number(this.max) - (Number(this.newNomineepercentone) + Number(this.newNomineepercentnto));
      this.thernompercentmax = d;

      if (Number(this.newNomineepercentnthre) > Number(this.thernompercentmax)) {
        this.newNomineepercentnthre = this.thernompercentmax;
      } else if (Number(this.newNomineepercentnthre) < 0) {
        this.newNomineepercentnthre = 0;
      }
    },
    selectOptionBtn() {
      // console.log("cjsjsakcnsioun", this.yesorno);
      if (this.yesorno == "yes") {
        this.nomineeForm = true;
      } else if (this.yesorno == "no") {
        this.nomineeForm = false;
      }
    },
    pincodeFetch() {
      var axiosThis = this;
      // console.warn("hh");
      // if (this.newNomineePincode.length >= 6) {
      //   let config = {
      //     method: "get",
      //     url: "https://api.postalpincode.in/pincode/" + this.newNomineePincode,
      //     headers: {},
      //   };

      //   axios
      //     .request(config)
      //     .then((response) => {
      //       axiosThis.pinLoader = false;

      //       // var resp = response.data[0].PostOffice[0];
      //       axiosThis.newNomineeState = resp.State;
      //       axiosThis.newNomineeCountry = resp.Country;
      //       axiosThis.newNomineeCity = resp.Division;

      //       // console.log(JSON.stringify(response.data));
      //     })
      //     .catch((error) => {
      //       axiosThis.pinLoader = false;

      //       console.log(error);
      //     });
      // }
      if (this.pincodeAddress.length >= 6) {
        this.pinLoader = true;
        let config = {
          method: "get",
          url: "https://api.postalpincode.in/pincode/" + this.pincodeAddress,
          headers: {},
        };

        axios
          .request(config)
          .then((response) => {
            axiosThis.pinLoader = false;

            var resp = response.data[0].PostOffice[0];
            axiosThis.stateAddress = resp.State;
            axiosThis.countryAddress = resp.Country;
            axiosThis.distAddress = resp.District;

            // console.log(JSON.stringify(response.data));
          })
          .catch((error) => {
            axiosThis.pinLoader = false;

            console.log(error);
          });
      }

      if (this.newNomineeGuardianPincode.length >= 6) {
        this.pinLoader = true;
        let config = {
          method: "get",
          url: "https://api.postalpincode.in/pincode/" + this.newNomineeGuardianPincode,
          headers: {},
        };

        axios
          .request(config)
          .then((response) => {
            axiosThis.pinLoader = false;

            var resp = response.data[0].PostOffice[0];
            axiosThis.newNomineeGuardianState = resp.State;
            axiosThis.newNomineeGuardianCountry = resp.Country;
            axiosThis.newNomineeGuardianCity = resp.Division;

            // console.log(JSON.stringify(response.data));
          })
          .catch((error) => {
            axiosThis.pinLoader = false;

            console.log(error);
          });
      }

      if (this.newNomineeGuardianPincodento.length >= 6) {
        this.pinLoader = true;
        let config = {
          method: "get",
          url: "https://api.postalpincode.in/pincode/" + this.newNomineeGuardianPincodento,
          headers: {},
        };

        axios
          .request(config)
          .then((response) => {
            axiosThis.pinLoader = false;

            var resp = response.data[0].PostOffice[0];
            axiosThis.newNomineeGuardianStatento = resp.State;
            axiosThis.newNomineeGuardianCountrynto = resp.Country;
            axiosThis.newNomineeGuardianCitynto = resp.Division;

            // console.log(JSON.stringify(response.data));
          })
          .catch((error) => {
            axiosThis.pinLoader = false;

            console.log(error);
          });
      }

      if (this.newNomineeGuardianPincodenthre.length >= 6) {
        this.pinLoader = true;
        let config = {
          method: "get",
          url: "https://api.postalpincode.in/pincode/" + this.newNomineeGuardianPincodenthre,
          headers: {},
        };

        axios
          .request(config)
          .then((response) => {
            axiosThis.pinLoader = false;

            var resp = response.data[0].PostOffice[0];
            axiosThis.newNomineeGuardianStatenthre = resp.State;
            axiosThis.newNomineeGuardianCountrynthre = resp.Country;
            axiosThis.newNomineeGuardianCitynthre = resp.Division;

            // console.log(JSON.stringify(response.data));
          })
          .catch((error) => {
            axiosThis.pinLoader = false;

            console.log(error);
          });
      }

      if (this.newNomineePincodento.length >= 6) {
        this.pinLoader = true;
        let config = {
          method: "get",
          url: "https://api.postalpincode.in/pincode/" + this.newNomineePincodento,
          headers: {},
        };

        axios
          .request(config)
          .then((response) => {
            axiosThis.pinLoader = false;

            var resp = response.data[0].PostOffice[0];
            axiosThis.newNomineeStatento = resp.State;
            axiosThis.newNomineeCountrynto = resp.Country;
            axiosThis.newNomineeCitynto = resp.Division;

            // console.log(JSON.stringify(response.data));
          })
          .catch((error) => {
            axiosThis.pinLoader = false;

            console.log(error);
          });
      }
      if (this.newNomineePincodenthre.length >= 6) {
        this.pinLoader = true;
        let config = {
          method: "get",
          url: "https://api.postalpincode.in/pincode/" + this.newNomineePincodenthre,
          headers: {},
        };

        axios
          .request(config)
          .then((response) => {
            axiosThis.pinLoader = false;

            var resp = response.data[0].PostOffice[0];
            axiosThis.newNomineeStatenthre = resp.State;
            axiosThis.newNomineeCountrynthre = resp.Country;
            axiosThis.newNomineeCitynthre = resp.Division;

            // console.log(JSON.stringify(response.data));
          })
          .catch((error) => {
            axiosThis.pinLoader = false;

            console.log(error);
          });
      }
    },
    digioEsign(file, email, session) {
      var axo = this;
      this.blurLoader = true;
      axo.editdialog = false;
      axo.esignconfirmation = false
      // localStorage.getItem("profileType");
      // console.log(file, email,session)
      // localStorage.setItem('fileid', this.digioFile)
      var options = {
        environment: "production",
        callback: function (t) {
          // axo.statusCheckNominee(axo.client_code);
          // console.log(t);
          // console.log(axo.stata);
          axo.blurLoader = false;

          if (axo.stata != undefined) {
            if (axo.stata.app_status == "e-signed pending") {
              axo.radioBtn = true;
              axo.nomineesubmitBtn = true;
            axo.fetchMobileStatus();

            } else {
              axo.radioBtn = false;
              axo.nomineesubmitBtn = false;
            }
          } else {
            axo.radioBtn = false;
            axo.nomineesubmitBtn = false;
          }

          if (t.message == "Signing cancelled") {
            // if(axo.editType == 'mobile_change') {
            axo.filedownloadDatabase("failure", file);
         

            // }
            // if(axo.editType == 'email_change') {
            // axo.filedownloadDatabase("failure", file);
            // axo.fetchMobileStatus()

            // }
            // if(axo.editType == 'address_change') {
            // axo.filedownloadDatabase("failure", file);
            // axo.fetchMobileStatus()
            // }
          } else if (t.message == "Signed Successfully") {
            // axo.filedownloadDatabase("success", axo.filedegio?axo.filedegio:axo.stata.file_id);
            // if(axo.editType == 'mobile_change') {

            axo.filedownloadDatabase("success", file);
            

            // }
            // if(axo.editType == 'email_change') {
            // axo.filedownloadDatabase("success", file);
            // }
            // if(axo.editType == 'address_change') {
            // axo.filedownloadDatabase("success", file);
            // }
          }

          if (t["hasOwnProperty"]("error_code")) {
            // document.getElementById("loading").style.display='none';
            //// console.log('Error Digio')
            //// console.log(t.message)
          } else {
            //document.getElementById("result").innerHTML="API Mandate Authentication Successful"
            //successDigio();
            //// console.log(this.step, this.ekycStatus);
            setTimeout(function () {
              //code goes here
              window.location.reload();
            }, 4500);
          }
        },
      };

      var digio = new Digio(options);
      digio.init(); // Call init on user action (eg.button press and proceed to asynchronous upload)
      // digio.submit(this.digioFile, this.digioMail,);
      // console.log(file,email,session)
      digio.submit(file, email, session);
      // digio.submit("DID230911100935062BG8PAZ3INK43XM", "mageshjack002@gmail.com","GWT2309111009374289K3NVXB6RHUEDO");

      // console.log(digio)
    },
    filedownloadDatabase(stat, fileid) {
      let data = JSON.stringify({
        client_id: this.client_code,
        file_id: fileid,
        response: stat,
        type: this.editType,
        email_id: this.profileData.CLIENT_ID_MAIL,
      });

      let config = {
        method: "post",

        // url: 'http://192.168.5.121:5555/filedownload',

        url: api.api_url + "/filedownload",
        headers: {
          Authorization: this.tok,
          clientid: this.profileData.CLIENT_ID,
          "Content-Type": "application/json",
        },
        data: data,
      };
      let axiosThis = this;

      axios
        .request(config)
        .then((response) => {
          axiosThis.fetchMobileStatus()
          if (response.data.emsg == "token expired") {
            axiosThis.snackbar = true;
            axiosThis.txt = "Expired";
            // console.warn("Hs")
            localStorage.clear();
            sessionStorage.clear();
            setTimeout(function () {
              // axiosThis.$router.push("/");
              axiosThis.goSso();
              window.location.reload();
            }, 2000);
          }
          if (response.data.emsg == "invalid token") {
            axiosThis.snackbar = true;
            axiosThis.txt = "Invalid";
            // console.warn("Hs")
            localStorage.clear();
            sessionStorage.clear();
            setTimeout(function () {
              // axiosThis.$router.push("/");
              axiosThis.goSso();

              window.location.reload();
            }, 2000);
          }
          // console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
          console.log(error);
        });
    },

    fetchMobileStatus() {
      this.blurLoader = true

      var axiosThis = this;
      let data = JSON.stringify({
        client_id: this.profileData.CLIENT_ID,
      });

      let config = {
        method: "post",
        url: api.api_url + "/add_mob_email_stat",
        headers: {
          Authorization: this.tok,
          clientid: this.profileData.CLIENT_ID,
          "Content-Type": "application/json",
        },
        data: data,
      };
      // console.log("jhasdgajb",this.client_code,this.tok)
      axios
        .request(config)
        .then((response) => {
          axiosThis.blurLoader = false
          // const stage = localStorage.getItem("dialogStage");
           console.log(response.data.acc_sgt_atve_sts,'---------acc_sgt_atve_sts');
           if(response.data.acc_sgt_atve_sts == "active" ){
            this.atve_sts=true;
           }

           console.log(response.data.last_7_days_check,'-------------last7days');
           if(response.data.last_7_days_check){
            this.last7days=true;
           }



          if (response.data.emsg == "token expired") {
            axiosThis.snackbar = true;
            axiosThis.txt = "Expired";
            // console.warn("Hs")
            localStorage.clear();
            sessionStorage.clear();
            setTimeout(function () {
              // axiosThis.$router.push("/");
              axiosThis.goSso();

              window.location.reload();
            }, 2000);
          }
          if (response.data.emsg == "invalid token") {
            axiosThis.snackbar = true;
            axiosThis.txt = "Expired";
            // console.warn("Hs")
            localStorage.clear();
            sessionStorage.clear();
            setTimeout(function () {
              // axiosThis.$router.push("/");
              axiosThis.goSso();

              window.location.reload();
            }, 2000);
          }
          if (response.data.emsg == "clientid not exist") {
            axiosThis.snackbar = true;
            axiosThis.txt = "Expired";
            // console.warn("Hs")
            localStorage.clear();
            sessionStorage.clear();
            setTimeout(function () {
              // axiosThis.$router.push("/");
              axiosThis.goSso();

              window.location.reload();
            }, 2000);
          }

          axiosThis.blurLoader = false;
          axiosThis.mobStatus = response.data;

          axiosThis.type =  localStorage.getItem("profileType");
          axiosThis.src =  localStorage.getItem("closebtn");
          // if (axiosThis.type === "email" || axiosThis.type === "mobile" || axiosThis.type === "address") {
          // }
          // localStorage.removeItem("profileType");

          
          const hasPendingEsign = axiosThis.mobStatus.mobile_status === "e-signed pending" || 
                                  axiosThis.mobStatus.email_status === "e-signed pending" || 
                                  axiosThis.mobStatus.address_status === "e-signed pending";

          
          const currentEsignConfirmation = axiosThis.esignconfirmation;

          
          if (axiosThis.type === 'mobile') {
            if (axiosThis.mobStatus.mobile_status === "e-signed pending") {
              axiosThis.diaesigntype = "mobile";
         
              if (!currentEsignConfirmation) {
                axiosThis.esignconfirmation = true;
              }
            } else if (axiosThis.mobStatus.mobile_status === "e-signed completed") {
            
              axiosThis.editdialog = false;
              
              if (!currentEsignConfirmation) {
                axiosThis.esignconfirmation = false;
              }
            } else {
             
              if (!hasPendingEsign) {
                axiosThis.mobileEdit(axiosThis.type);
              } else {
               
                axiosThis.editdialog = false;
              
                if (!currentEsignConfirmation) {
                  axiosThis.esignconfirmation = false;
                }
              }
            }
          } else if (axiosThis.type === 'email') {
            if (axiosThis.mobStatus.email_status === "e-signed pending") {
              axiosThis.diaesigntype = "email";
              
              if (!currentEsignConfirmation) {
                axiosThis.esignconfirmation = true;
              }
            } else if (axiosThis.mobStatus.email_status === "e-signed completed") {
             
              axiosThis.editdialog = false;
             
              if (!currentEsignConfirmation) {
                axiosThis.esignconfirmation = false;
              }
              
            } else {
              
              if (!hasPendingEsign) {
                axiosThis.mobileEdit(axiosThis.type);
              } else {
                
                axiosThis.editdialog = false;
               
                if (!currentEsignConfirmation) {
                  axiosThis.esignconfirmation = false;
                }
              }
            }
          } else if (axiosThis.type === 'address') {
            if (axiosThis.mobStatus.address_status === "e-signed pending") {
              axiosThis.diaesigntype = "address";
              
              if (!currentEsignConfirmation) {
                axiosThis.esignconfirmation = true;
              }
            } else if (axiosThis.mobStatus.address_status === "e-signed completed") {
              
              axiosThis.editdialog = false;
              
              if (!currentEsignConfirmation) {
                axiosThis.esignconfirmation = false;
              }
            } else {
              
              if (!hasPendingEsign) {
                axiosThis.mobileEdit(axiosThis.type);
              } else {
               
                axiosThis.editdialog = false;
                
                if (!currentEsignConfirmation) {
                  axiosThis.esignconfirmation = false;
                }
              }
            }
          } else {
           
            if(axiosThis.mobStatus.mobile_status == "e-signed pending"){
              axiosThis.diaesigntype = "mobile";
              if (axiosThis.type === 'mobile'){
               
                if (!currentEsignConfirmation) {
                  axiosThis.esignconfirmation = true;
                }
              }
            } else if(axiosThis.mobStatus.mobile_status !== "e-signed pending"){
              
              if (!hasPendingEsign) {
                axiosThis.mobileEdit(axiosThis.type);
              } else {
                
                axiosThis.editdialog = false;
                
                if (!currentEsignConfirmation) {
                  axiosThis.esignconfirmation = false;
                }
              }
            }
            if(axiosThis.mobStatus.mobile_status == "e-signed completed"){
              axiosThis.editdialog = false;
            }

            if (axiosThis.mobStatus.email_status === "e-signed pending") {
              axiosThis.diaesigntype = "email";
              if (axiosThis.type === 'email') {
               
                if (!currentEsignConfirmation) {
                  axiosThis.esignconfirmation = true;
                }
              }
            } else if (axiosThis.mobStatus.email_status !== "e-signed pending" && axiosThis.mobStatus.email_status === "e-signed completed"){
              axiosThis.editdialog = false;
              
              if (!currentEsignConfirmation) {
                axiosThis.esignconfirmation = false;
              }
              
              if (!hasPendingEsign) {
                axiosThis.mobileEdit(axiosThis.type);
              }
            }

            if(axiosThis.mobStatus.address_status == "e-signed pending"){
              axiosThis.diaesigntype = "address";
              if(axiosThis.type === 'address'){
                
                if (!currentEsignConfirmation) {
                  axiosThis.esignconfirmation = true;
                }
              }                   
            } else if(axiosThis.mobStatus.address_status !== "e-signed pending"){
              
              if (!hasPendingEsign) {
                axiosThis.mobileEdit(axiosThis.type);
              } else {
                
                axiosThis.editdialog = false;
               
                if (!currentEsignConfirmation) {
                  axiosThis.esignconfirmation = false;
                }
              }
            }
          }

          if (axiosThis.mobStatus.mobile_status == "e-signed pending" || axiosThis.mobStatus.address_status == "e-signed pending" || axiosThis.mobStatus.email_status == "e-signed pending") {
            // document.getElementById("mobileedit").removeAttribute(":append-icon");
            axiosThis.mobileDisable = true;
            axiosThis.emailDisable = true;
            axiosThis.addressDisable = true;
          }
          if (axiosThis.mobStatus.address_status == "e-signed completed" || axiosThis.mobStatus.address_status == "e-signed pending") {
            // document.getElementById("mobileedit").removeAttribute(":append-icon");
            axiosThis.addressDisable = true;
          }
          if (axiosThis.mobStatus.mobile_status == "e-signed completed" || axiosThis.mobStatus.mobile_status == "e-signed pending") {
            // document.getElementById("mobileedit").removeAttribute(":append-icon");
            axiosThis.mobileDisable = true;
          }
          if (axiosThis.mobStatus.email_status == "e-signed completed" || axiosThis.mobStatus.email_status == "e-signed pending") {
            // document.getElementById("mobileedit").removeAttribute(":append-icon");
            axiosThis.emailDisable = true;
          }
          if (axiosThis.mobStatus.income_status == "e-signed completed" || axiosThis.mobStatus.income_status == "e-signed pending") {
            // document.getElementById("mobileedit").removeAttribute(":append-icon");
            axiosThis.yearlyIncomeDisable = true;
          }

          // ?page=app auto open, kept last so the status branches above
          // cannot close the dialog right after it is opened
          if (axiosThis.autoOpenAddress) {
            axiosThis.autoOpenAddress = false;
            if (!axiosThis.addressDisable) {
              axiosThis.mobileEdit("address");
            }
          }

          // back from Digilocker, selfie check is already done before the
          // redirect. Kept last for the same reason as the auto open above
          if (axiosThis.digilockerReturn) {
            axiosThis.digilockerReturn = false;
            if (!axiosThis.addressDisable) {
              axiosThis.digiFileWrite();
            }
          }

        })
        .catch((error) => {
          axiosThis.blurLoader = false

          console.log(error);
        });
    },
    otpFileWrite() {
      var axiosThis = this;
      if (this.currentClick == "mobile") {
        axiosThis.requestotp = true;
        axiosThis.verifyotp = false;
        axiosThis.successSnackbar = true;
        axiosThis.mobileLoader = false;
        axiosThis.blurLoader = true;

        const date = new Date();
        const offset = date.getTimezoneOffset() == 0 ? 0 : -1 * date.getTimezoneOffset();

        let normalized = new Date(date.getTime() + offset * 60000);
        let indiaTime = new Date(
          normalized.toLocaleString("en-US", {
            timeZone: "Asia/Calcutta",
          })
        );

        // console.log("Time in India::", indiaTime.toISOString());
        var dateAndTime = indiaTime.toISOString();

        let data = JSON.stringify({
          pres_mobile_no: axiosThis.usernewmobile,
          client_id: axiosThis.client_code,
          prev_mobile_no: axiosThis.profileData.MOBILE_NO,
          client_name: axiosThis.name,
          client_email: axiosThis.profileData.CLIENT_ID_MAIL.toUpperCase(),
          dp_code: axiosThis.profileData.CLIENT_DP_CODE,
          date_time: dateAndTime,
          pan: axiosThis.profileData.PAN_NO,
        });

        let config = {
          method: "post",

          url: api.api_url + "/file_write_mob",
          headers: {
            Authorization: axiosThis.tok,
            clientid: axiosThis.profileData.CLIENT_ID,
            "Content-Type": "application/json",
          },
          data: data,
        };

        axios
          .request(config)
          .then((response) => {
            // console.log(JSON.stringify(response.data));
            // axiosThis.digioEsign(responceReq.fileid, responceReq.mailid)
            var responceReq = response.data;
            if (responceReq.fileid && responceReq.mailid) {
              // Set esignconfirmation first, then fetch status
              axiosThis.esignconfirmation = true;
              axiosThis.diaesigntype = "mobile";
              axiosThis.fetchMobileStatus();
              // axiosThis.digioEsign(responceReq.fileid, responceReq.mailid, responceReq.session);
            } else {
              axiosThis.blurLoader = false;
              axiosThis.successSnackbar = false;
              axiosThis.errorSnackbar = true;
              axiosThis.errtext = responceReq;
            }
          })
          .catch((error) => {
            console.log(error);
          });

        axiosThis.Succtext = "OTP Verified";
        axiosThis.editdialog = false;
        axiosThis.usernewmobile = "";
        axiosThis.userOtp = "";
      }
    },
    emailOtpfileWrite() {
      var axiosThis = this;
      // if(this.currentClick == 'email') {

      axiosThis.blurLoader = true;
      // axiosThis.requestotp = true;

      axiosThis.successSnackbar = true;
      axiosThis.verifyotp = false;
      axiosThis.requestotp = true;
      axiosThis.userOtp = "";
      axiosThis.usernewmobile = "";
      (axiosThis.usernewemail = ""), (axiosThis.requestotpemail = false), (axiosThis.useremailOtp = ""), (axiosThis.verifyotpemail = false);
      axiosThis.Succtext = "OTP Verfified Sucessfully";
      // axiosThis.connectDigio()

      const date = new Date();
      const offset = date.getTimezoneOffset() == 0 ? 0 : -1 * date.getTimezoneOffset();

      let normalized = new Date(date.getTime() + offset * 60000);
      let indiaTime = new Date(
        normalized.toLocaleString("en-US", {
          timeZone: "Asia/Calcutta",
        })
      );

      // console.log("Time in India::", indiaTime.toISOString());
      var dateAndTime = indiaTime.toISOString();

      let data = JSON.stringify({
        client_id: axiosThis.client_code,
        client_email: axiosThis.profileData.CLIENT_ID_MAIL.toUpperCase(),
        dp_code: axiosThis.profileData.CLIENT_DP_CODE,
        date_time: dateAndTime,
        present_email: axiosThis.userEmailadress.toUpperCase(),
        previous_email: axiosThis.profileData.CLIENT_ID_MAIL.toUpperCase(),
        client_name: axiosThis.name,
        pan: axiosThis.profileData.PAN_NO,
      });
      axiosThis.blurLoader = true;

      let config = {
        method: "post",

        url: api.api_url + "/file_write_email",
        headers: {
          Authorization: axiosThis.tok,
          clientid: axiosThis.profileData.CLIENT_ID,
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          var responceReq = response.data;
          if (responceReq.fileid && responceReq.mailid) {
            // Set esignconfirmation first, then fetch status
            axiosThis.esignconfirmation = true;
            axiosThis.diaesigntype = "email";
            axiosThis.fetchMobileStatus();
            // axiosThis.digioEsign(responceReq.fileid, responceReq.mailid, responceReq.session);
          } else {
            axiosThis.successSnackbar = false;

            axiosThis.blurLoader = false;
            axiosThis.errorSnackbar = true;
            axiosThis.errtext = responceReq;
          }
        })
        .catch((error) => {
          axiosThis.blurLoader = false;

          console.log(error);
        });

      axiosThis.editdialog = false;
      // }
    },
    digiFileWrite() {
      var axiosThis = this;

      // let params = (new URL(document.location)).searchParams;
      let token = this.aadharcode;
      let state = this.aadharstate;
      this.editType = "address_change";
      const FormData = require("form-data");
      let data = new FormData();
      data.append("file", "");
      data.append("proff", "");
      data.append("cur_address", "");
      data.append("ext_address", this.profileData.CL_RESI_ADD1);
      data.append("dp_code", this.profileData.CLIENT_DP_CODE);
      data.append("client_id", this.client_code);
      data.append("client_name", this.name);
      data.append("client_email", this.profileData.CLIENT_ID_MAIL.toUpperCase());
      data.append("aadhar_address", "");
      data.append("adr_manual", "aadhar");
      data.append("code", token);
      data.append("state", state);
      data.append("pan", this.profileData.PAN_NO);

      // let config = {
      //   method: 'post',
      //   //
      //   url: api.api_url+'/adr_chn',
      //   headers: {
      //   },
      //   data : data
      // };

      // axios.request(config)
      axios
        .post(api.api_url + "/adr_chn", data, {
          headers: {
            Authorization: this.tok,
            clientid: this.profileData.CLIENT_ID,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          axiosThis.adresschange = false;
          axiosThis.editdialog = false;
          console.log("1111111111111111111111111111");
          
          if (response.data.fileid) {
            // Set esignconfirmation first, then fetch status
            axiosThis.esignconfirmation = true;
            axiosThis.diaesigntype = "address";
            axiosThis.fetchMobileStatus();
            // axiosThis.digioEsign(response.data.fileid, response.data.mailid, response.data.session);
          } else {
            axiosThis.errorSnackbar = true;
            axiosThis.errtext = "Error in Server, please try again later";
          }
          axiosThis.$router.replace("/");
          // window.location.assign(window.location.href.split('?')[0])

          // const query = this.$route.query;
          //   delete query.code;
          //   delete query.state;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    kraImageCheck() {
      var axiosThis = this;
      let config = {
        method: "get",
        url: "https://ekycbe.mynt.in/zebu/check_client_image/" + this.client_code,
        headers: {
          "Content-Type": "application/json",
        },
      };

      axios
        .request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          if (response.data == true) {
            axiosThis.proceedAfterImageCheck();
          } else {
            axiosThis.checkingImgFallback();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkingImgFallback() {
      var axiosThis = this;
      let config = {
        method: "get",
        url: api.api_url + "/checking_img/" + this.client_code,
        headers: {
          "Content-Type": "application/json",
        },
      };

      axios
        .request(config)
  
        .then((response) => {
          if (response.data.data == true) {
            axiosThis.proceedAfterImageCheck();
          } else {
            axiosThis.verifyotp = false;
            axiosThis.kraImgCapture = true;
            axiosThis.verifyotpemail = false;
            axiosThis.adresschange = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    proceedAfterImageCheck() {
      if (this.currentClick == "mobile") {
        this.otpFileWrite();
      } else if (this.currentClick == "email") {
        this.emailOtpfileWrite();
      } else if (this.currentClick == "address") {
        if (this.manual) {
          this.manualAdressSubmit();
        } else {
          this.connectDigio();
        }
      }
    },
    otpButtonClicked() {
      this.tok = localStorage.getItem("usession");

      var axiosThis = this;
      if (this.currentClick == "mobile") {
        var valid = this.$refs.formm.validate();
        if (valid == true) {
          // console.log("josi");
          this.mobileLoader = true;
          // this.blurLoader = true

          var data = JSON.stringify({
            pres_mobile_no: this.usernewmobile,
            client_id: this.client_code,
            mobile_otp: this.userOtp,
            prev_mobile_no: this.profileData.MOBILE_NO,
            client_name: this.name,
            client_email: this.profileData.CLIENT_ID_MAIL.toUpperCase(),
            dp_code: this.profileData.CLIENT_DP_CODE,
          });
          // var enc = this.encryptionFunction(dall);
          // console.log("status payload", enc, dall);
          // let data = JSON.stringify({
          //   string: enc,
          // });

          let config = {
            method: "post",
            // url: api.api_url+"/mob_otp_ver",
            url: api.api_url + "/mob_otp_ver",

            headers: {
              Authorization: this.tok,
              clientid: this.profileData.CLIENT_ID,
              "Content-Type": "application/json",
            },
            data: data,
          };

          axios
            .request(config)
            .then((response) => {
              axiosThis.mobileLoader = false;
              // var res = axiosThis.decryptionFunction(response.data.str);
              // console.warn(response);
              if (response.data.emsg == "token expired") {
                axiosThis.snackbar = true;
                axiosThis.txt = "Expired";
                // console.warn("Hs")
                localStorage.clear();
                sessionStorage.clear();
                setTimeout(function () {
                  // axiosThis.$router.push("/");
                  axiosThis.goSso();

                  window.location.reload();
                }, 2000);
              }
              if (response.data.emsg == "invalid token") {
                axiosThis.snackbar = true;
                axiosThis.txt = "Invalid";
                // console.warn("Hs")
                localStorage.clear();
                sessionStorage.clear();
                setTimeout(function () {
                  // axiosThis.$router.push("/");
                  axiosThis.goSso();

                  window.location.reload();
                }, 2000);
              }
              var responceReq = response.data;
              // console.log(response.data.message);
              if (responceReq.msg == "otp valid") {
                axiosThis.kraImageCheck();
              } else {
                axiosThis.errorSnackbar = true;
                axiosThis.errtext = "otp not valid";
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
      if (this.currentClick == "email") {
        //// console.log("email otp verify", this.$refs.emailform);
        var emailvalid = this.$refs.formemailveri.validate();
        if (emailvalid == true) {
          // this.blurLoader = true

          // console.log("josi");
          let data = JSON.stringify({
            client_id: this.client_code,
            present_email: this.userEmailadress.toUpperCase(),
            emailotp: this.useremailOtp,
          });

          let config = {
            method: "post",
            url: api.api_url + "/mail_otpverify",
            headers: {
              Authorization: this.tok,
              clientid: this.profileData.CLIENT_ID,
              "Content-Type": "application/json",
            },
            data: data,
          };

          axios
            .request(config)
            .then((response) => {
            localStorage.removeItem("profileType");
              if (response.data.emsg == "token expired") {
                axiosThis.snackbar = true;
                axiosThis.txt = "Expired";
                // console.warn("Hs")
                localStorage.clear();
                sessionStorage.clear();
                setTimeout(function () {
                  // axiosThis.$router.push("/");
                  axiosThis.goSso();

                  window.location.reload();
                }, 2000);
              }
              if (response.data.emsg == "invalid token") {
                axiosThis.snackbar = true;
                axiosThis.txt = "Invalid";
                // console.warn("Hs")
                localStorage.clear();
                sessionStorage.clear();
                setTimeout(function () {
                  // axiosThis.$router.push("/");
                  axiosThis.goSso();

                  window.location.reload();
                }, 2000);
              }
              // console.log(response.data.msg);
              if (response.data.msg == "otp valid") {
                axiosThis.kraImageCheck();
                // @click="kraImageCheck"
              } else {
                axiosThis.errorSnackbar = true;
                axiosThis.errtext = "Invalid OTP";
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
      // console.log("submit clik");
    },

    checkKraandsentOTP() {
      var axiosThis = this;
      if (this.kraImgCapture) {
        if (this.isPhotoTaken) {
          var source = this.capturedImage;
          if (!source) {
            this.errtext = "No image captured";
            this.errorSnackbar = true;
            return;
          }

          // Always send at 350x260 to match old code (backend fits it on PDF)
          var sendCanvas = document.createElement('canvas');
          sendCanvas.width = 350;
          sendCanvas.height = 260;
          var sendCtx = sendCanvas.getContext('2d');

          if (this.isUploadedPhoto) {
            // Upload: crop selected region, then fit into 350x260
            var origX = this.previewSx + (this.cropX / 475) * this.previewSw;
            var origY = this.previewSy + (this.cropY / 520) * this.previewSh;
            var origW = (this.cropW / 475) * this.previewSw;
            var origH = (this.cropH / 520) * this.previewSh;
            sendCtx.drawImage(source, origX, origY, origW, origH, 0, 0, 350, 260);
          } else {
            // Camera capture: full frame scaled to 350x260 (same as old code)
            sendCtx.drawImage(source, 0, 0, 350, 260);
          }

          sendCanvas.toBlob(
            (blob) => {
              this.imageURL = blob;
              let data = new FormData();
              data.append("image", blob, "photo.jpg");
              data.append("client_id", this.client_code);

              let config = {
                method: "post",
                url: api.api_url + "/img_upload",
                headers: {
                  "Content-Type": "multipart/form-data",
                },
                data: data,
              };

              axios
                .request(config)
                .then((response) => {
                  if (response.data.data == "image saved") {
                    this.isCameraOpen = false;
                    this.isPhotoTaken = false;
                    this.isShotPhoto = false;
                    this.isUploadedPhoto = false;
                    this.stopCameraStream();
                    this.kraImgCapture = false;
                    this.editdialog = false;
                    this.capturedImage = null;
                    if (this.currentClick == "mobile") {
                      this.otpFileWrite();
                    } else if (this.currentClick == "email") {
                      this.emailOtpfileWrite();
                    } else if (this.currentClick == "address") {
                      if (this.adressObject) {
                        this.manualAdressSubmit();
                      } else {
                        this.connectDigio();
                      }
                    }
                  } else {
                    axiosThis.errtext = response.data.data;
                    axiosThis.errorSnackbar = true;
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            },
            "image/jpeg",
            0.8
          );
        } else {
          this.errtext = "Kindly take a selfi";
          this.errorSnackbar = true;
        }
      }
    },
    sendButtonClicked() {
      this.tok = localStorage.getItem("usession");

      var axiosThis = this;
      if (this.currentClick == "mobile") {
        var emailvalid = this.$refs.form.validate();
        if (emailvalid == true) {
          this.mobileLoader = true;

          this.cardLoader = true;
          // console.log("josi");
          var dall = JSON.stringify({
            prev_mobile_no: this.profileData.MOBILE_NO,
            pres_mobile_no: this.usernewmobile,
            client_id: this.client_code,
            client_name: this.name,
            client_email: this.profileData.CLIENT_ID_MAIL.toUpperCase(),
          });
          // var enc = this.encryptionFunction(dall);
          // console.log("status payload", dall);
          // let data = JSON.stringify({
          //   string: enc,
          // });
          let data = dall;

          let config = {
            method: "post",
            url: api.api_url + "/mob_otp_req",
            headers: {
              Authorization: this.tok,
              clientid: this.profileData.CLIENT_ID,
              "Content-Type": "application/json",
            },
            data: data,
          };

          axios
            .request(config)
            .then((response) => {
              if (response.data.emsg == "token expired") {
                axiosThis.snackbar = true;
                axiosThis.txt = "Expired";
                // console.warn("Hs")
                localStorage.clear();
                sessionStorage.clear();
                setTimeout(function () {
                  // axiosThis.$router.push("/");
                  axiosThis.goSso();

                  window.location.reload();
                }, 2000);
              }
              if (response.data.emsg == "invalid token") {
                axiosThis.snackbar = true;
                axiosThis.txt = "Invalid";
                // console.warn("Hs")
                localStorage.clear();
                sessionStorage.clear();
                setTimeout(function () {
                  // axiosThis.$router.push("/");
                  axiosThis.goSso();

                  window.location.reload();
                }, 2000);
              }
              // var res = axiosThis.decryptionFunction(response.data.str);
              // console.warn(response);
              axiosThis.mobileLoader = false;

              var responceReq = response.data;
              axiosThis.cardLoader = false;
              // console.log(JSON.stringify(response.data));
              if (responceReq.msg == "otp sent") {
                axiosThis.requestotp = false;
                axiosThis.verifyotp = true;

                axiosThis.Succtext = "OTP Sent";
                axiosThis.successSnackbar = true;
                // localStorage.setItem("dialogStage", "2");
              } else if (responceReq.msg == "already this mobile number used") {
                axiosThis.usernewmobile = "";
                axiosThis.errorSnackbar = true;
                axiosThis.errtext = "Entered Number was already available";
              } else if (responceReq.msg == "This number already linked to another account") {
                axiosThis.usernewmobile = "";
                axiosThis.errorSnackbar = true;
                axiosThis.errtext = responceReq.msg;
              }
            })
            .catch((error) => {
              axiosThis.cardLoader = false;
              console.log(error);
            });
        }
      }
      if (this.currentClick == "email") {
        var valid = this.$refs.formemailreq.validate();
        if (valid == true) {
          this.emailLoader = true;
          this.cardLoader = true;
          // console.log("email");
          this.userEmailadress = this.usernewemail;
          let data = JSON.stringify({
            client_id: this.client_code,
            previous_email: this.profileData.CLIENT_ID_MAIL,
            present_email: this.usernewemail.toUpperCase(),
            client_name: this.name,
          });

          let config = {
            method: "post",
            url: api.api_url + "/mail_otpsend",
            headers: {
              Authorization: this.tok,
              clientid: this.profileData.CLIENT_ID,
              "Content-Type": "application/json",
            },
            data: data,
          };

          axios
            .request(config)
            .then((response) => {
              if (response.data.emsg == "token expired") {
                axiosThis.snackbar = true;
                axiosThis.txt = "Expired";
                // console.warn("Hs")
                localStorage.clear();
                sessionStorage.clear();
                setTimeout(function () {
                  // axiosThis.$router.push("/");
                  axiosThis.goSso();

                  window.location.reload();
                }, 2000);
              }
              if (response.data.emsg == "invalid token") {
                axiosThis.snackbar = true;
                axiosThis.txt = "Invalid";
                // console.warn("Hs")
                localStorage.clear();
                sessionStorage.clear();
                setTimeout(function () {
                  // axiosThis.$router.push("/");
                  axiosThis.goSso();

                  window.location.reload();
                }, 2000);
              }
              // axiosThis.cardLoader = false;
              axiosThis.emailLoader = false;

              // console.log(JSON.stringify(response.data));
              if (response.data.msg == "success send mail") {
                axiosThis.requestotpemail = false;
                axiosThis.verifyotpemail = true;
                // localStorage.setItem("dialogStage", "2");

              } else if (response.data.msg == "Mobile already exists") {
                axiosThis.mobileNumber = "";
                axiosThis.errorSnackbar = true;
                axiosThis.errtext = "Entered Number was already available";
              } else {
                axiosThis.mobileNumber = "";
                axiosThis.errorSnackbar = true;
                axiosThis.errtext = response.data.msg;
              }
            })
            .catch((error) => {
              axiosThis.cardLoader = false;
              console.log(error);
            });
        }
      }
    },
    manualAdressSubmit() {
      this.tok = localStorage.getItem("usession");

      var axiosThis = this;
      var addressvalid = this.$refs.formadress.validate();
      if (addressvalid == true) {
        this.addressLoader = true;

        const FormData = require("form-data");
        let data = new FormData();
        this.adressObject = JSON.stringify({
          address: this.usernewAdress,
          pincode: this.pincodeAddress,
          state: this.stateAddress.toUpperCase(),
          dist: this.distAddress.toUpperCase(),
          country: this.countryAddress.toUpperCase(),
        });
        data.append("file", this.panFile);
        data.append("proff", this.proofTypes);
        data.append("cur_address", this.adressObject);
        data.append("ext_address", this.profileData.CL_RESI_ADD1);
        data.append("dp_code", this.profileData.CLIENT_DP_CODE);
        data.append("client_id", this.client_code);
        data.append("client_name", this.name);
        data.append("client_email", this.profileData.CLIENT_ID_MAIL.toUpperCase());
        data.append("aadhar_address", "");
        data.append("adr_manual", "manual");
        data.append("code", "");
        data.append("state", "");
        data.append("pan", this.profileData.PAN_NO);

        // let config = {
        //   method: 'post',
        //   //
        //   url: api.api_url+'/adr_chn',
        //   headers: {
        //   },
        //   data : data
        // };

        // axios.request(config)
        axios
          .post(api.api_url + "/adr_chn", data, {
            headers: {
              Authorization: this.tok,
              clientid: this.profileData.CLIENT_ID,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            // console.log(JSON.stringify(response.data));
            axiosThis.blurLoader = false;

            axiosThis.adresschange = false;
            axiosThis.editdialog = false;      
            if (response.data.fileid) {
              axiosThis.fetchMobileStatus()
              axiosThis.esignconfirmation = true;
              // localStorage.setItem("dialogStage", "2");
              // axiosThis.digioEsign(response.data.fileid, response.data.mailid, response.data.session);
            } else {
              axiosThis.errorSnackbar = true;
              axiosThis.errtext = "Error in Server, please try again later";
              
            }
            axiosThis.addressLoader = false;
          })
          .catch((error) => {
            console.log(error);
            axiosThis.addressLoader = false;
          });
      }
    },
    digilockerAdressSubmit(a, b) {
      // var axiosThis = this;
      // console.log("inn", a, b);
      // let params = (new URL(document.location)).searchParams;
      this.blurLoader = true;

      let token = this.aadharcode;
      let state = this.aadharstate;

      // var url_data = this.$route.params;
      // console.log(token,"poiuytrewqqqqqqasdfghjkllkmnbvcxz");

      // var addressvalid = this.$refs.formadress.validate();
      if (token && state) {
        // console.log("inn if");

        this.editType = "address_change";
        const FormData = require("form-data");
        let data = new FormData();
        data.append("file", "");
        data.append("proff", "");
        data.append("cur_address", "");
        data.append("ext_address", this.profileData.CL_RESI_ADD1);
        data.append("dp_code", this.profileData.CLIENT_DP_CODE);
        data.append("client_id", this.client_code);
        data.append("client_name", this.name);
        data.append("client_email", this.profileData.CLIENT_ID_MAIL.toUpperCase());
        data.append("aadhar_address", "");
        data.append("adr_manual", "aadhar");
        data.append("code", token);
        data.append("state", state);
        data.append("pan", this.profileData.PAN_NO);

        // let config = {
        //   method: 'post',
        //   //
        //   url: api.api_url+'/adr_chn',
        //   headers: {
        //   },
        //   data : data
        // };

        // axios.request(config)
        let axiosThis = this;
        axios
          .post(api.api_url + "/adr_chn", data, {
            headers: {
              Authorization: this.tok,
              clientid: this.profileData.CLIENT_ID,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            // console.log(JSON.stringify(response.data), response, 'DIGI');
            axiosThis.adresschange = false;
            axiosThis.editdialog = false;
            axiosThis.blurLoader = false;
      
          console.log("333333333333333333333333333333");
          window.history.replaceState({}, document.title, window.location.pathname);
            if (response.data.fileid) {
              axiosThis.fetchMobileStatus()
              axiosThis.esignconfirmation = true
              // axiosThis.digioEsign(response.data.fileid, response.data.mailid, response.data.session);
            } else {
              axiosThis.errorSnackbar = true;
              axiosThis.errtext = "Error in Server, please try again later";
            }
            // axiosThis.$router.replace("/");
            // window.location.assign(window.location.href.split('?')[0])
            // const query = this.$route.query;
            //   delete query.code;
            //   delete query.state;
          })
          .catch((error) => {
            console.log(error);
            axiosThis.blurLoader = false;

          });
      } else {
        this.blurLoader = false;

        // console.log("inn else", token, state, a, b);
      }
    },
    paswordverificationBtn() {
      // this.annualincomeOtpReq()
      this.tok = localStorage.getItem("usession");

      // var valid = this.$refs.incomeupdate.validate();
      // console.log(valid)
      if (this.passwordRequired == true) {
        // var fd = this.$refs.incomeupdate.validate();
        // console.log("<<<<<<<<<<<<<",fd)
        var axiosThis = this;
        // this.passwordField = false;
        const FormData = require("form-data");
        let data = new FormData();
        data.append("client_id", this.client_code);
        data.append("password", this.pdfPassword);
        data.append("proff_file", this.panFile);

        let config = {
          method: "post",
          url: api.api_url + "/pdf_password_check",
          headers: {
            Authorization: this.tok,
            clientid: this.profileData.CLIENT_ID,
            "Content-Type": "multipart/form-data",
          },
          data: data,
        };
        axios
          .request(config)
          .then((response) => {
            // console.log(response.data);
            if (response.data["password required"] == "In-Correct") {
              axiosThis.pdfPassword = "";
              axiosThis.errorSnackbar = true;
              axiosThis.errtext = "Incorrect Password";

              axiosThis.passwordField = true;
              axiosThis.paswordverification = true;
            } else {
              axiosThis.annualincomeOtpReq();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (this.panFile && this.selectionas == 4) {
        this.annualincomeOtpReq();
      } else if (!this.panFile && this.selectionas !== 4) {
        this.annualincomeOtpReq();
      } else {
        this.errorSnackbar = true;
        this.errtext = "Upload proof";
      }
    },
    checkSame() {
      if (this.profileData.MOBILE_NO == this.usernewmobile) {
        this.usernewmobile = "";
        this.errorSnackbar = true;
        this.errtext = "Enter your new Mobile number";
      }
    },
    ifscFetch(ifsc) {
      var axiosThis = this;
      this.bankIfscCode = this.bankIfscCode.toUpperCase();
      if (ifsc.indexOf(" ") >= 0) {
        // console.log("contains spaces");
        this.bankIfscCode = ifsc.replace(/\s+/g, "");
      }
      if (this.bankIfscCode.length >= 11) {
        let config = {
          method: "get",
          url: "https://ifsc.razorpay.com/" + ifsc,
          headers: {},
        };

        axios
          .request(config)
          .then((response) => {
            // console.log(response.data);
            axiosThis.ifscBankInfo = response.data;
          })
          .catch((error) => {
            axiosThis.ifscBankInfo = [];
            console.log(error);
          });
      }
    },
    incomeproof() {
      if (this.selectionas == 4) {
        this.proofField = true;
      } else {
        this.proofField = false;
        this.passwordField = false;
        this.incorrectPass = false;
      }
    },

    passHide() {
      // let file = e.target.files[0] || e.dataTransfer.files[0]
      //           this.panFile = file;

      var axiosThis = this;
      this.passwordField = false;
      const FormData = require("form-data");
      let data = new FormData();
      data.append("client_id", this.client_code);
      data.append("proff_file", this.panFile);

      let config = {
        method: "post",
        url: api.api_url + "/pdf_lock",
        headers: {
          Authorization: this.tok,
          clientid: this.profileData.CLIENT_ID,
          "Content-Type": "multipart/form-data",
        },
        data: data,
      };
      axios
        .request(config)
        .then((response) => {
          // console.log(response.data);
          if (response.data["password required"] == "True") {
            axiosThis.passwordField = true;
            axiosThis.passwordRequired = true;
            // axiosThis.paswordverification = true
          } else {
            axiosThis.passwordRequired = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    encryptionFunction(payld) {
      var CryptoJS = require("crypto-js");

      const payload = payld;
      var derived_key = CryptoJS.enc.Base64.parse(btoa("N#j2L^8pq9Fb$d@1")); //YXNkZmdoamtsenhjdmJubQ==
      var iv = CryptoJS.enc.Utf8.parse("3790514682037125");
      var test = CryptoJS.AES.encrypt(payload, derived_key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
      }).toString();
      return test;
    },
    decryptionFunction(payld) {
      var CryptoJS = require("crypto-js");

      const payload = payld;
      const derived_key = CryptoJS.enc.Base64.parse(btoa("N#j2L^8pq9Fb$d@1")); //YXNkZmdoamtsenhjdmJubQ==
      const iv = CryptoJS.enc.Utf8.parse("3790514682037125");
      const encryptedData = payload;

      // Decrypt the data using AES
      const decrypted = CryptoJS.AES.decrypt(encryptedData, derived_key, {
        iv,
        mode: CryptoJS.mode.CBC,
      });
      const decryptedData = decrypted.toString(CryptoJS.enc.Utf8);

      // console.log('Decrypted Data:', decryptedData);
      return decryptedData;
    },
    mobileEdit(data) {
      // Non-individual accounts can't modify profile data (also covers URL/auto-open paths)
      if (this.profileData && this.profileData.CATEGORY && this.profileData.CATEGORY != 'I') return;
      this.tok = localStorage.getItem("usession");
      // address change is only served from profile.mynt.in, so hand the
      // session over there and let ?page=app re-open this dialog on arrival
      if (data == "address" && window.location.hostname == "profile.zebuetrade.com") {
        var uid = localStorage.getItem("userid");
        var usession = localStorage.getItem("usession");
        window.location.assign(
          `https://profile.mynt.in/?uid=${encodeURIComponent(uid)}&token=${encodeURIComponent(usession)}&page=app`
        );
        return;
      }
      this.dialogType = data;
      if (data == "mobile") {
        // this.$router.push(`/profile/mobilechange`);
        this.currentClick = "mobile";
        // this.editType = "mobile_change";
        // this.cardTitle = 'Mobile Number Verification'
        this.subTitle = "Enter your new mobile number";
        this.requestotp = true;
        this.requestotpemail = false;
        this.bankchange = false;
        this.editdialog = true;

        this.annualIncomechange = false;
        this.mobileLoader = false;

        this.nosegmentsPop = false;
        this.segments = false;

        this.adresschange = false;
        // this.addressVerification = false;
      }
      if (data == "email") {
        // this.$router.push(`/profile/emailchange`);
        this.currentClick = "email";
        this.editType = "email_change";
        this.requestotpemail = true;
        this.requestotp = false;
        this.editdialog = true;

        this.nosegmentsPop = false;
        this.bankchange = false;
        this.annualIncomechange = false;
        this.annualIncomeverifyotp = false;
        this.segments = false;

        // this.addressVerification = false;
        this.adresschange = false;
        // this.cardTitle = 'Email Number Verification'
        this.subTitle = "Enter your new email number";
      }
      if (data == "address") {
        // this.$router.push(`/profile/addresschange`);
        this.currentClick = "address";
        this.editType = "address_change";
        this.adressOptions = true;
        this.manual = false;
        this.nosegmentsPop = false;
        this.editdialog = true;
        
        this.requestotp = false;
        this.requestotpemail = false;
        this.adresschange = true;
        this.bankchange = false;
        this.annualIncomechange = false;
        this.annualIncomeverifyotp = false;
        this.segments = false;

        // this.cardTitle = 'Email Number Verification'
        this.subTitle = "Would you like to change adressd ";
      }
      this.kraImgCapture = false;
    },
    getAvailBal() {
      var axiosThis = this;

      axiosThis.blurLoader = false;
      axiosThis.profileLoader = false;
      // console.log(response)

      axiosThis.equty = [];
      axiosThis.derivat = [];
      axiosThis.commoditi = [];

      // console.log(response.data.str)
      var res = axiosThis.decryptionFunction(localStorage.getItem("profile_data"));
      // console.log("pppp",JSON.parse(res));
      var resp = JSON.parse(res);
      axiosThis.profileData = resp.client_data;
      axiosThis.hashpan = axiosThis.profileData.PAN_NO.slice(-3);
      axiosThis.BankData = resp.bank_data;

      axiosThis.name = axiosThis.profileData.CLIENT_NAME;
      // console.log(axiosThis.name)
      localStorage.setItem("client_name", axiosThis.name);
      //   if(typeof axiosThis.name == 'string'){
      // }
      // axiosThis.$router.push("/");

      axiosThis.client_code = axiosThis.profileData.CLIENT_ID;

      if (axiosThis.profileData.Nominee_Name) {
        // axiosThis.multinominee = resp.
        axiosThis.nomineeYes = true;
        axiosThis.newNomineeName = axiosThis.profileData.Nominee_Name;
        axiosThis.newNomineeRelation = axiosThis.profileData.Nominee_Relation;
        axiosThis.newNomineeDob = axiosThis.profileData.Nominee_DOB;
        // axiosThis.newNomineepercent = axiosThis.profileData.Nominee_Name
      }
      axiosThis.fetchMobileStatus();

      axiosThis.profileData.CL_RESI_ADD1 = axiosThis.profileData.CL_RESI_ADD1 + " " + axiosThis.profileData.CL_RESI_ADD2 + " " + axiosThis.profileData.CL_RESI_ADD3;
      for (var i = 0; i < axiosThis.profileData.segments_data.length; i++) {
        // console.log(axiosThis.profileData.segments_data[i].COMPANY_CODE);
        if (axiosThis.profileData.segments_data[i].COMPANY_CODE == "BSE_CASH" || axiosThis.profileData.segments_data[i].COMPANY_CODE == "MF_NSE" || axiosThis.profileData.segments_data[i].COMPANY_CODE == "NSE_CASH" || axiosThis.profileData.segments_data[i].COMPANY_CODE == "MF_BSE") {
          axiosThis.equty.push(axiosThis.profileData.segments_data[i]);
        }
        if (axiosThis.profileData.segments_data[i].COMPANY_CODE == "NSE_FNO" || axiosThis.profileData.segments_data[i].COMPANY_CODE == "BSE_FNO" || axiosThis.profileData.segments_data[i].COMPANY_CODE == "CD_BSE" || axiosThis.profileData.segments_data[i].COMPANY_CODE == "CD_NSE") {
          axiosThis.derivat.push(axiosThis.profileData.segments_data[i]);
        }
        if (axiosThis.profileData.segments_data[i].COMPANY_CODE == "BSE_COM" || axiosThis.profileData.segments_data[i].COMPANY_CODE == "NSE_COM" || axiosThis.profileData.segments_data[i].COMPANY_CODE == "MCX" || axiosThis.profileData.segments_data[i].COMPANY_CODE == "ICEX") {
          axiosThis.commoditi.push(axiosThis.profileData.segments_data[i]);
        }
      }
    },
    chipp() {
      this.chha = !this.chha;
    },
    getCardColor(index) {
      // Custom logic to determine the card color based on the index or other conditions
      if (index % 2 === 0) {
        return "#ECF9EF"; // Example: Blue color for even index cards
      } else {
        return "#FAEAEA"; // Example: Green color for odd index cards
      }
    },
    autoOpenPage() {
      // ?page=app on the login url (persisted by LayOut) opens the address
      // change request dialog after login, once only. The dialog itself is
      // opened at the end of fetchMobileStatus, since that response decides
      // whether address editing is allowed at all.
      var page = localStorage.getItem("openpage");
      if (page == "app") {
        localStorage.removeItem("openpage");
        this.autoOpenAddress = true;
      }
    },
    closeBtn() {
      this.editdialog = false;
      this.verifyotp = false;
      this.requestotp = true;
      this.userOtp = "";
      this.usernewmobile = "";
      (this.usernewemail = ""), (this.requestotpemail = false), (this.useremailOtp = ""), (this.verifyotpemail = false), (this.stateAddress = ""), (this.countryAddress = ""), (this.distAddress = ""), (this.pincodeAddress = "");
      (this.usernewAdress = ""), (this.adressproffdoc = null), (this.bankIfscCode = ""), (this.bankAccountnumber = ""), (this.bankproofTypes = ""), (this.bankproffdoc = null), (this.defaultCheckbox = false);

      this.isCameraOpen = false;
      this.isPhotoTaken = false;
      this.isShotPhoto = false;
      this.isUploadedPhoto = false;
      this.capturedImage = null;
      this.stopCameraStream();
    },
  },
  computed: {
    mobileNumberRules() {
      return [(value) => /^\d{10}$/.test(value) || "Enter a valid number"];
    },
    otpRules() {
      return [(value) => !!value || "OTP Required", (value) => /^\d{4}$/.test(value) || "Must be exactly 4 digits"];
    },
    nomineeField() {
      return [(value) => !!value || "Required field"];
    },
    emailNumberRules() {
      return [(value) => !!value || "email id is required", (value) => /.+@.+\..+/.test(value) || "Email must be valid"];
    },
    depedselectRules() {
      return [(value) => !!value || "Dependent name is required"];
    },
  },
  mounted() {
    // this.loadModelsAndStartVideo();
    // console.log("mounted");
    this.blurLoader = true;
    let params = new URL(document.location).searchParams;
    // var axiosThis = this;
    var cod = params.get("code");
    var stat = params.get("state");
    var error = params.get("error");
    var vendorAcc = params.get("sAccountId");
    var vendorToken = params.get("sToken");
    this.accountstatus = localStorage.getItem("clientStatus");
    // console.log("jiji", vendorAcc, vendorToken);

    // console.log("////",cod,stat)
    if (cod && stat) {
      this.aadharstate = stat;
      this.aadharcode = cod;
      this.digilockerReturn = true;
      // this.digilockerAdressSubmit(cod, stat);
    }

    if (error) {
      this.errorSnackbar = true;
      this.errtext = params.get("error_description");
    }
    // let decoded = decodeURIComponent(window.location.search);
    var actid = params.get("uid");
    var token = params.get("token");
    this.susertoken = localStorage.getItem("usession");
    // console.log(this.susertoken,actid,window.location.search)
    this.actid = localStorage.getItem("userid");
    var reloading = false;
    if (typeof actid == "string" && typeof token == "string") {
      localStorage.setItem("usession", token);
      localStorage.setItem("userid", actid);
      this.susertoken = localStorage.getItem("usession");
      this.actid = localStorage.getItem("userid");
      reloading = true;
      window.location.assign(window.location.href.split("?")[0]);
    }
      this.rkycstatuscheck()
    if (vendorAcc == null && vendorToken == null) {
      // console.warn("nully")
      if (this.susertoken && this.actid) {
        var id = this.actid;
        this.tok = this.susertoken;
        // console.log("ifififififififif", this.tok);
        // skip on the pass that is stripping the query string away,
        // the dialog opens after the reload instead
        if (!reloading) {
          this.autoOpenPage();
        }
        this.getAvailBal(id);
      
      } else {
        this.goSso();
      }
    }
    
  },
};
    
const $ = document.querySelector.bind(document);
const $$ = document.querySelectorAll.bind(document);

let activeLink = null;

window.addEventListener("scroll", () => {
  $$(".section").forEach((section) => {
    const {y} = section.getBoundingClientRect();

    if (y <= 0) {
      if (activeLink != null) {
        activeLink.classList.remove("active");
      }

      activeLink = $(`.nav-link[href~="#${section.id}"]`);
      activeLink.classList.add("active");
    }
  });
});
</script>
